(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7734],{

/***/ 74565:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():0}(this,(function(){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var o=t[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)r.d(n,o,function(t){return e[t]}.bind(null,o));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=54)}({0:function(e,t){e.exports=__webpack_require__(67294)},1:function(e,t){e.exports=__webpack_require__(45697)},54:function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var n=i(r(1)),o=i(r(0)),u=["size"];function i(e){return e&&e.__esModule?e:{default:e}}function l(){return(l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e}).apply(this,arguments)}function f(e,t){if(null==e)return{};var r,n,o=function(e,t){if(null==e)return{};var r,n,o={},u=Object.keys(e);for(n=0;n<u.length;n++)r=u[n],t.indexOf(r)>=0||(o[r]=e[r]);return o}(e,t);if(Object.getOwnPropertySymbols){var u=Object.getOwnPropertySymbols(e);for(n=0;n<u.length;n++)r=u[n],t.indexOf(r)>=0||Object.prototype.propertyIsEnumerable.call(e,r)&&(o[r]=e[r])}return o}var c=function(e){var t=e.size,r=f(e,u);return o.default.createElement("svg",l({viewBox:"0 0 20 20",fill:"currentColor",width:t||"20",height:t||"20"},r),o.default.createElement("path",{d:"M8.53033 14.2478L8 13.7175L7.46967 14.2478C7.76256 14.5407 8.23744 14.5407 8.53033 14.2478ZM8 12.6569L4.53033 9.18718C4.23744 8.89429 3.76256 8.89429 3.46967 9.18718C3.17678 9.48008 3.17678 9.95495 3.46967 10.2478L7.46967 14.2478L8 13.7175L8.53033 14.2478L16.2478 6.53033C16.5407 6.23743 16.5407 5.76256 16.2478 5.46967C15.955 5.17677 15.4801 5.17677 15.1872 5.46967L8 12.6569Z",fill:"currentColor",fillRule:"evenodd",clipRule:"evenodd"}))};c.displayName="Check",c.propTypes={size:n.default.string},c.__docgenInfo={description:"",methods:[],displayName:"Check",props:{size:{type:{name:"string"},required:!1,description:""}}};var a=c;t.default=a}})}));

/***/ }),

/***/ 48109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useContactSalesTypeform; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var contexts_generic_config_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3156);
/* harmony import */ var services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77784);
/* harmony import */ var services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var services_typeform_typeform_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15728);
/* harmony import */ var _constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13979);
/* harmony import */ var client_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53989);
/* harmony import */ var _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65023);







function useContactSalesTypeform(param) {
    var abTests = param.abTests, fallbackLink = param.fallbackLink;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isShowingTypeform = ref[0], setIsShowingTypeform = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(contexts_generic_config_context__WEBPACK_IMPORTED_MODULE_1__/* .GenericConfigContext */ .Z), forcePricing = ref1.forcePricing, useNewTypeformUSVariant = ref1.useNewTypeformUSVariant, cookies = ref1.cookies, forceCurrency = ref1.forceCurrency, cloudfrontViewerCountry = ref1.cloudfrontViewerCountry, isV13PricingVersion = ref1.isV13PricingVersion, testTypeformContactSales = ref1.testTypeformContactSales, forceTypeformContactSalesExperience = ref1.forceTypeformContactSalesExperience, contactSalesTestMode = ref1.contactSalesTestMode;
    var onCallback = function() {
        setIsShowingTypeform(false);
    };
    var displayTypeform = function() {
        var getNewVariantForTest = useNewTypeformUSVariant || (0,services_ab_tests_acquisition_ab_test_service__WEBPACK_IMPORTED_MODULE_2__.shouldUseNewTypeformVariant)(abTests, true);
        var pricingData = {
            forcePricing: forcePricing,
            cookies: cookies,
            abTests: abTests,
            forceCurrency: forceCurrency,
            countryCode: cloudfrontViewerCountry,
            isV13PricingVersion: isV13PricingVersion
        };
        if ((0,services_typeform_typeform_service__WEBPACK_IMPORTED_MODULE_3__/* .shouldGetTypeformExperience */ .ap)({
            abTests: abTests,
            cloudfrontViewerCountry: cloudfrontViewerCountry,
            testTypeformContactSales: testTypeformContactSales,
            forceTypeformContactSalesExperience: forceTypeformContactSalesExperience,
            sendBigBrainEvent: true
        })) {
            try {
                setIsShowingTypeform(true);
                (0,_constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_4__/* .openContactSalesTypeform */ ._X)({
                    country: cloudfrontViewerCountry,
                    deviceType: _constants_typeform_contact_sales__WEBPACK_IMPORTED_MODULE_4__/* .TYPEFORM_DESKTOP_DEVICE_TYPE */ .PM,
                    getNewVariantForTest: getNewVariantForTest,
                    isTest: contactSalesTestMode,
                    pricingData: pricingData,
                    onCloseCallback: onCallback,
                    onSubmitCallback: onCallback,
                    onReadyCallback: onCallback
                });
            } catch (e) {
                var bbEventParams = {
                    name: _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_6__.TYPEFORM_UNHANDLED_EXCEPTION
                };
                (0,client_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_5__/* .handleClientException */ .N)({
                    e: e,
                    bbEventParams: bbEventParams
                });
                window.location = fallbackLink;
            }
        }
    };
    return {
        isShowingTypeform: isShowingTypeform,
        displayTypeform: displayTypeform
    };
}


/***/ }),

/***/ 79926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CarouselGallary; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/nuka-carousel/es/index.js + 13 modules
var es = __webpack_require__(46499);
// EXTERNAL MODULE: ./components/core/button/button-component.js + 5 modules
var button_component = __webpack_require__(20776);
// EXTERNAL MODULE: ./services/utils-service.js
var utils_service = __webpack_require__(20618);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./components/core/carousel-gallary/decorators/bottom-center-points.scss.js


var StyledBottomCenterPoints = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", {
    target: "egoyoe40"
})(".bottom-center-point-button{color:", colors/* default.black */.Z.black, ";&:focus{color:", colors/* default.brand-blue */.Z["brand-blue"], ";}}");

;// CONCATENATED MODULE: ./components/core/carousel-gallary/decorators/bottom-center-points.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}





var BottomCenterPoints = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BottomCenterPoints, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BottomCenterPoints);
    function BottomCenterPoints(props) {
        (0,_class_call_check/* default */.Z)(this, BottomCenterPoints);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "onDotClick", function(index) {
            var _props = _this.props, goToSlide = _props.goToSlide, bottomCenterExtraProps = _props.bottomCenterExtraProps;
            var onButtonClick = bottomCenterExtraProps.onButtonClick;
            if ((0,utils_service.isFunction)(onButtonClick)) {
                onButtonClick(index);
            }
            goToSlide(index);
        });
        _this.getIndexes = _this.getIndexes.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.getListStyles = _this.getListStyles.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.getListItemStyles = _this.getListItemStyles.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.getButtonStyles = _this.getButtonStyles.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(BottomCenterPoints, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var self = this;
                var _props = this.props, slideCount = _props.slideCount, slidesToScroll = _props.slidesToScroll, currentSlide = _props.currentSlide;
                var indexes = this.getIndexes(slideCount, slidesToScroll);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBottomCenterPoints, {
                    style: this.getListStyles(),
                    children: indexes.map(function(index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            style: self.getListItemStyles(),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                tabIndex: 0,
                                className: "bottom-center-point-button",
                                style: self.getButtonStyles(currentSlide === index),
                                onClick: function() {
                                    return _this.onDotClick(index);
                                },
                                onMouseDown: accessibility_service/* preventFocusOnMouseDown */.$R,
                                children: "•"
                            })
                        }, index);
                    })
                });
            }
        },
        {
            key: "getIndexes",
            value: function getIndexes(count, inc) {
                var arr = [];
                for(var i = 0; i < count; i += inc){
                    arr.push(i);
                }
                return arr;
            }
        },
        {
            key: "getListStyles",
            value: function getListStyles() {
                return {
                    position: "relative",
                    margin: 0,
                    top: -10,
                    padding: 0,
                    width: "100vw",
                    display: "flex",
                    justifyContent: "center"
                };
            }
        },
        {
            key: "getListItemStyles",
            value: function getListItemStyles() {
                return {
                    listStyleType: "none",
                    display: "inline-block"
                };
            }
        },
        {
            key: "getButtonStyles",
            value: function getButtonStyles(active) {
                return {
                    border: 0,
                    background: "transparent",
                    cursor: "pointer",
                    padding: 10,
                    outline: 0,
                    fontSize: 24,
                    opacity: active ? 1 : 0.5
                };
            }
        }
    ]);
    return BottomCenterPoints;
}(react.PureComponent);

BottomCenterPoints.defaultProps = {
    bottomCenterExtraProps: {}
};

;// CONCATENATED MODULE: ./components/core/carousel-gallary/carousel-gallary.js





function carousel_gallary_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            carousel_gallary_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var getSettings = function(param) {
    var bottomCenterExtraProps = param.bottomCenterExtraProps;
    return {
        renderBottomCenterControls: function(param) {
            var currentSlide = param.currentSlide, slideCount = param.slideCount, goToSlide = param.goToSlide, slidesToScroll = param.slidesToScroll;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomCenterPoints, {
                currentSlide: currentSlide,
                slideCount: slideCount,
                goToSlide: goToSlide,
                slidesToScroll: slidesToScroll,
                bottomCenterExtraProps: bottomCenterExtraProps
            });
        }
    };
};
var CarouselGallary = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CarouselGallary, PureComponent);
    var _super = (0,_create_super/* default */.Z)(CarouselGallary);
    function CarouselGallary(props) {
        (0,_class_call_check/* default */.Z)(this, CarouselGallary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            carouselSlideIndex: props.slideIndex
        };
        _this.afterCarouselSlide = _this.afterCarouselSlide.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(CarouselGallary, [
        {
            key: "afterCarouselSlide",
            value: function afterCarouselSlide(slideIndex) {
                var afterSlide = this.props.afterSlide;
                this.setState({
                    carouselSlideIndex: slideIndex
                }, function() {
                    if ((0,utils_service.isFunction)(afterSlide)) {
                        afterSlide(slideIndex);
                    }
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, children = _props.children, bottomCenterExtraProps = _props.bottomCenterExtraProps;
                var carouselSlideIndex = this.state.carouselSlideIndex;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.ZP, _object_spread_props(_object_spread({}, getSettings({
                    bottomCenterExtraProps: bottomCenterExtraProps
                }), this.props), {
                    afterSlide: this.afterCarouselSlide,
                    children: react.Children.map(children, function(child, index) {
                        return /*#__PURE__*/ (0,react.cloneElement)(child, {
                            isCurrentSlide: carouselSlideIndex == index
                        });
                    })
                }));
            }
        }
    ]);
    return CarouselGallary;
}(react.PureComponent);

CarouselGallary.defaultProps = {
    bottomCenterExtraProps: {}
};


/***/ }),

/***/ 87852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ label; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/background-image-cards-grid/card-button/label/label.scss.js


var StyledLabel = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eqx6xni0"
})("border:", function(param) {
    var borderColor = param.borderColor;
    return "1px solid ".concat(colors/* default */.Z[borderColor]);
}, ";color:", function(param) {
    var borderColor = param.borderColor;
    return colors/* default */.Z[borderColor];
}, ";padding:4px 8px;margin:auto;border-radius:4px;width:fit-content;font-size:0.875rem;");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/background-image-cards-grid/card-button/label/label.js


var Label = function(param) {
    var text = param.text, borderColor = param.borderColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLabel, {
        className: "generic-text",
        borderColor: borderColor,
        children: text
    });
};
/* harmony default export */ var label = (Label);


/***/ }),

/***/ 31099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ prices_and_features_cards_pricing_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./services/ab-tests/monetization-ab-tests-service.js + 2 modules
var monetization_ab_tests_service = __webpack_require__(46724);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/prices-and-features-cards-pricing/default-props.js
/* harmony default export */ var default_props = ({
    currencyValue: "usd",
    signupButtonText: "signup.tryForFree",
    contactUsButtonText: "footer.contactUs",
    defaultSeatsIndex: 0
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/pricing/constants.js
var constants = __webpack_require__(83473);
// EXTERNAL MODULE: ./segments/desktop/pricing/product-pricing-config.js
var product_pricing_config = __webpack_require__(69535);
// EXTERNAL MODULE: ./components/core/carousel-gallary/carousel-gallary.js + 2 modules
var carousel_gallary = __webpack_require__(79926);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./services/sales-enrichment/sales-enrichment-service.js
var sales_enrichment_service = __webpack_require__(29919);
// EXTERNAL MODULE: ./constants/pricing.js
var pricing = __webpack_require__(55674);
// EXTERNAL MODULE: ./services/pricing/plans-service.js
var plans_service = __webpack_require__(56492);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/background-image-cards-grid/card-button/label/label.js + 1 modules
var label = __webpack_require__(87852);
// EXTERNAL MODULE: ./utils/react.js
var utils_react = __webpack_require__(12783);
// EXTERNAL MODULE: ./utils/strings.js
var strings = __webpack_require__(11685);
var strings_default = /*#__PURE__*/__webpack_require__.n(strings);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./components/enhancements/tooltip/tooltip-component.js + 1 modules
var tooltip_component = __webpack_require__(31590);
// EXTERNAL MODULE: ./components/enhancements/tooltip/tooltip-constants.js
var tooltip_constants = __webpack_require__(24984);
// EXTERNAL MODULE: ./components/core/button/button-component.js + 5 modules
var button_component = __webpack_require__(20776);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./constants/localization.js
var localization = __webpack_require__(72632);
;// CONCATENATED MODULE: ./services/pricing-learn-more-service.js



var _obj, _obj1, _obj2, _obj3, _obj4, _obj5, _obj6;
var LEARN_MORE_VIDEOS_BY_LOCALE_AND_TIER = (_obj6 = {}, (0,_define_property/* default */.Z)(_obj6, localization.ENGLISH_LOCALE_ID, (_obj = {}, (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.STANDARD */.Iy.STANDARD, "AJZPfiy4MvQ"), (0,_define_property/* default */.Z)(_obj, pricing/* TIERS.PRO */.Iy.PRO, "EktHUKbOjVU"), _obj)), (0,_define_property/* default */.Z)(_obj6, localization.SPANISH_LOCALE_ID, (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, pricing/* TIERS.STANDARD */.Iy.STANDARD, "pc3pyOJ2nYI"), (0,_define_property/* default */.Z)(_obj1, pricing/* TIERS.PRO */.Iy.PRO, "_3poht9VbHA"), _obj1)), (0,_define_property/* default */.Z)(_obj6, localization.FRENCH_LOCALE_ID, (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, pricing/* TIERS.STANDARD */.Iy.STANDARD, "e0L8cjyQdgM"), (0,_define_property/* default */.Z)(_obj2, pricing/* TIERS.PRO */.Iy.PRO, "uzEuF0sPqpM"), _obj2)), (0,_define_property/* default */.Z)(_obj6, localization.PORTUGEESE_LOCALE_ID, (_obj3 = {}, (0,_define_property/* default */.Z)(_obj3, pricing/* TIERS.STANDARD */.Iy.STANDARD, "QQBtWCk-HQU"), (0,_define_property/* default */.Z)(_obj3, pricing/* TIERS.PRO */.Iy.PRO, "_QqhH-BMncM"), _obj3)), (0,_define_property/* default */.Z)(_obj6, localization.GERMAN_LOCALE_ID, (_obj4 = {}, (0,_define_property/* default */.Z)(_obj4, pricing/* TIERS.STANDARD */.Iy.STANDARD, "diS3_WWhG30"), (0,_define_property/* default */.Z)(_obj4, pricing/* TIERS.PRO */.Iy.PRO, "Ahdwi6K3K_o"), _obj4)), (0,_define_property/* default */.Z)(_obj6, localization.JAPANESE_LOCALE_ID, (_obj5 = {}, (0,_define_property/* default */.Z)(_obj5, pricing/* TIERS.STANDARD */.Iy.STANDARD, "3EVQBrQZfJU"), (0,_define_property/* default */.Z)(_obj5, pricing/* TIERS.PRO */.Iy.PRO, "OksNX5QN62c"), _obj5)), _obj6);
var getVideoIdByLocaleAndTier = function(locale, tier) {
    var _LEARN_MORE_VIDEOS_BY_LOCALE_AND_TIER_locale;
    var fallback = LEARN_MORE_VIDEOS_BY_LOCALE_AND_TIER[localization.ENGLISH_LOCALE_ID][tier];
    var _LEARN_MORE_VIDEOS_BY_LOCALE_AND_TIER_locale_tier;
    return (_LEARN_MORE_VIDEOS_BY_LOCALE_AND_TIER_locale_tier = (_LEARN_MORE_VIDEOS_BY_LOCALE_AND_TIER_locale = LEARN_MORE_VIDEOS_BY_LOCALE_AND_TIER[locale]) === null || _LEARN_MORE_VIDEOS_BY_LOCALE_AND_TIER_locale === void 0 ? void 0 : _LEARN_MORE_VIDEOS_BY_LOCALE_AND_TIER_locale[tier]) !== null && _LEARN_MORE_VIDEOS_BY_LOCALE_AND_TIER_locale_tier !== void 0 ? _LEARN_MORE_VIDEOS_BY_LOCALE_AND_TIER_locale_tier : fallback;
};
var hasLearnMoreVideo = function hasLearnMoreVideo(tier) {
    return tier in LEARN_MORE_VIDEOS_BY_LOCALE_AND_TIER[localization.ENGLISH_LOCALE_ID];
};

// EXTERNAL MODULE: ./segments/desktop/core-components/button/youtube-popup-button/youtube-popup-button.js + 3 modules
var youtube_popup_button = __webpack_require__(25101);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./client/services/hooks/use-contact-cales-typeform.js
var use_contact_cales_typeform = __webpack_require__(48109);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
// EXTERNAL MODULE: ./segments/desktop/pricing/icons/product-icon.js + 10 modules
var product_icon = __webpack_require__(51511);
// EXTERNAL MODULE: ./static/svg/pricing-info-icon.svg
var pricing_info_icon = __webpack_require__(89046);
;// CONCATENATED MODULE: ./static/svg/pricing-enterprise-icon.svg
var _mask, _rect, _mask2, _path, _mask3, _path2, _mask4, _rect2, _mask5, _path3, _mask6, _path4, _mask7, _rect3, _mask8, _rect4, _mask9, _path5;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgPricingEnterpriseIcon = function SvgPricingEnterpriseIcon(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 92,
        height: 72,
        fill: "none",
        viewBox: "0 0 92 72"
    }, props), _mask || (_mask = /*#__PURE__*/ react.createElement("mask", {
        id: "path-1-inside-1_3284_211859",
        fill: "#fff"
    }, /*#__PURE__*/ react.createElement("rect", {
        width: 47.208,
        height: 24.296,
        y: 47.16,
        rx: 1.433
    }))), _rect || (_rect = /*#__PURE__*/ react.createElement("rect", {
        width: 47.208,
        height: 24.296,
        y: 47.16,
        stroke: "#323338",
        strokeWidth: 5.73,
        mask: "url(#path-1-inside-1_3284_211859)",
        rx: 1.433
    })), _mask2 || (_mask2 = /*#__PURE__*/ react.createElement("mask", {
        id: "path-2-inside-2_3284_211859",
        fill: "#fff"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M8.583 44.306c0-.792.642-1.433 1.433-1.433h8.58c.79 0 1.432.641 1.432 1.433v5.713H8.583z"
    }))), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#323338",
        strokeWidth: 5.73,
        d: "M8.583 44.306c0-.792.642-1.433 1.433-1.433h8.58c.79 0 1.432.641 1.432 1.433v5.713H8.583z",
        mask: "url(#path-2-inside-2_3284_211859)"
    })), _mask3 || (_mask3 = /*#__PURE__*/ react.createElement("mask", {
        id: "path-3-inside-3_3284_211859",
        fill: "#fff"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M26.797 44.306c0-.792.64-1.433 1.432-1.433h8.58c.79 0 1.432.641 1.432 1.433v5.713H26.797z"
    }))), _path2 || (_path2 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#323338",
        strokeWidth: 5.73,
        d: "M26.797 44.306c0-.792.64-1.433 1.432-1.433h8.58c.79 0 1.432.641 1.432 1.433v5.713H26.797z",
        mask: "url(#path-3-inside-3_3284_211859)"
    })), _mask4 || (_mask4 = /*#__PURE__*/ react.createElement("mask", {
        id: "path-4-inside-4_3284_211859",
        fill: "#fff"
    }, /*#__PURE__*/ react.createElement("rect", {
        width: 47.208,
        height: 24.296,
        x: 18.597,
        y: 4.287,
        rx: 1.433
    }))), _rect2 || (_rect2 = /*#__PURE__*/ react.createElement("rect", {
        width: 47.208,
        height: 24.296,
        x: 18.597,
        y: 4.287,
        stroke: "#323338",
        strokeWidth: 5.73,
        mask: "url(#path-4-inside-4_3284_211859)",
        rx: 1.433
    })), _mask5 || (_mask5 = /*#__PURE__*/ react.createElement("mask", {
        id: "path-5-inside-5_3284_211859",
        fill: "#fff"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M27.18 1.433C27.18.64 27.822 0 28.614 0h8.58c.79 0 1.432.641 1.432 1.433v5.713H27.18z"
    }))), _path3 || (_path3 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#323338",
        strokeWidth: 5.73,
        d: "M27.18 1.433C27.18.64 27.822 0 28.614 0h8.58c.79 0 1.432.641 1.432 1.433v5.713H27.18z",
        mask: "url(#path-5-inside-5_3284_211859)"
    })), _mask6 || (_mask6 = /*#__PURE__*/ react.createElement("mask", {
        id: "path-6-inside-6_3284_211859",
        fill: "#fff"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M45.777 1.433C45.777.64 46.418 0 47.209 0h8.58c.791 0 1.432.641 1.432 1.433v5.713H45.777z"
    }))), _path4 || (_path4 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#323338",
        strokeWidth: 5.73,
        d: "M45.777 1.433C45.777.64 46.418 0 47.209 0h8.58c.791 0 1.432.641 1.432 1.433v5.713H45.777z",
        mask: "url(#path-6-inside-6_3284_211859)"
    })), _mask7 || (_mask7 = /*#__PURE__*/ react.createElement("mask", {
        id: "path-7-inside-7_3284_211859",
        fill: "#fff"
    }, /*#__PURE__*/ react.createElement("rect", {
        width: 47.208,
        height: 24.296,
        x: 44.347,
        y: 25.723,
        rx: 1.433
    }))), _rect3 || (_rect3 = /*#__PURE__*/ react.createElement("rect", {
        width: 47.208,
        height: 24.296,
        x: 44.347,
        y: 25.723,
        stroke: "#323338",
        strokeWidth: 5.73,
        mask: "url(#path-7-inside-7_3284_211859)",
        rx: 1.433
    })), _mask8 || (_mask8 = /*#__PURE__*/ react.createElement("mask", {
        id: "path-8-inside-8_3284_211859",
        fill: "#fff"
    }, /*#__PURE__*/ react.createElement("rect", {
        width: 47.208,
        height: 24.296,
        x: 44.347,
        y: 47.16,
        rx: 1.433
    }))), _rect4 || (_rect4 = /*#__PURE__*/ react.createElement("rect", {
        width: 47.208,
        height: 24.296,
        x: 44.347,
        y: 47.16,
        stroke: "#323338",
        strokeWidth: 5.73,
        mask: "url(#path-8-inside-8_3284_211859)",
        rx: 1.433
    })), _mask9 || (_mask9 = /*#__PURE__*/ react.createElement("mask", {
        id: "path-9-inside-9_3284_211859",
        fill: "#fff"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M71.527 22.868c0-.791.64-1.432 1.432-1.432h8.58c.79 0 1.432.64 1.432 1.432v5.713H71.526z"
    }))), _path5 || (_path5 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#323338",
        strokeWidth: 5.73,
        d: "M71.527 22.868c0-.791.64-1.432 1.432-1.432h8.58c.79 0 1.432.64 1.432 1.432v5.713H71.526z",
        mask: "url(#path-9-inside-9_3284_211859)"
    })));
};
/* harmony default export */ var pricing_enterprise_icon = (SvgPricingEnterpriseIcon);

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/prices-and-features-cards-pricing/product-prices-and-features-cards/product-price-and-features-card/contact-us-icon.js

var ContactUsIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "70",
        height: "64",
        viewBox: "0 0 70 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20.7533 50.8641C21.726 50.4148 22.832 50.3383 23.8582 50.6493C27.2353 51.6726 30.9105 52.2372 34.7712 52.2372C52.445 52.2372 65.1989 40.7866 65.1989 28.4008C65.1989 16.0091 52.445 4.56139 34.7712 4.56139C17.0971 4.56139 4.34418 16.0091 4.34659 28.4C4.34659 34.7429 7.55133 40.6962 13.1472 45.1352C14.7487 46.4057 15.237 48.6134 14.3188 50.4321L12.0774 54.871L20.7533 50.8641ZM2.60656 64.0005L10.4323 48.5018C3.99148 43.3925 4.40334e-07 36.2732 4.40334e-07 28.4008C-0.00302297 12.8511 15.5637 0.250488 34.7712 0.250488C53.9787 0.250488 69.5455 12.8511 69.5455 28.4008C69.5455 43.9445 53.9787 56.5481 34.7712 56.5481C30.4834 56.5481 26.38 55.9211 22.5881 54.7721L2.60656 64.0005Z",
            fill: "currentColor"
        })
    });
};

// EXTERNAL MODULE: ./services/pricing-service.js + 2 modules
var pricing_service = __webpack_require__(15650);
// EXTERNAL MODULE: ./services/pricing/product-prices.js
var product_prices = __webpack_require__(43331);
// EXTERNAL MODULE: ./client/services/exceptions-handling-service/exceptions-handling-service.js
var exceptions_handling_service = __webpack_require__(53989);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/prices-and-features-cards-pricing/product-prices-and-features-cards/product-price-and-features-card/product-price/product-price.scss.js

var StyledProductPrice = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1eealuk0"
})("height:140px;.price-tag{margin:8px 0 8px 0;display:flex;justify-content:flex-start;align-items:flex-end;.amount{font-size:2.7rem;margin-right:4px;font-weight:600;}.price-description{line-height:18px;font-size:0.8125rem;color:#323338;margin-bottom:4px;}}.price-currency-text{font-size:8px;font-weight:bold;margin-left:4px;}.product-price-total-wrapper{display:flex;gap:5px;}.product-price-billed-periodically{font-size:0.875rem;}.product-price-total{font-size:0.875rem;font-weight:bold;}");

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/prices-and-features-cards-pricing/product-prices-and-features-cards/product-price-and-features-card/product-price/product-price.js









var ProductPrice = function(param) {
    var period = param.period, seats = param.seats, tierName = param.tierName, product = param.product, hideFreeForever = param.hideFreeForever, splitCurrencySign = param.splitCurrencySign;
    var ref = (0,react.useContext)(generic_config_context/* GenericConfigContext */.Z), translate = ref.translate, translateOrTranslateWithParam = ref.translateOrTranslateWithParam, currencyFromContext = ref.currency, pricingVersion = ref.pricingVersion, localeId = ref.localeId, forceCurrency = ref.forceCurrency, cloudfrontViewerCountry = ref.cloudfrontViewerCountry, cookies = ref.cookies, forcePricing = ref.forcePricing, abTests = ref.abTests;
    var currency = currencyFromContext || (0,pricing_service/* getCurrencyName */.c0)({
        forceCurrency: forceCurrency,
        countryCode: cloudfrontViewerCountry
    });
    var productPricePerMonth = product_prices/* productPrices */.A[product][pricingVersion][period][tierName][currency];
    var corePricePerMonth = (0,react.useMemo)(function() {
        return product_prices/* productPrices.core */.A.core[pricingVersion][period][tierName][currency];
    }, [
        period,
        tierName,
        pricingVersion,
        currency
    ]);
    var totalPricePerMonth = product === "core" ? productPricePerMonth : productPricePerMonth + corePricePerMonth;
    if (totalPricePerMonth === undefined) {
        var params = {
            product: product,
            period: period,
            currency: currency,
            tierName: tierName,
            seats: seats
        };
        (0,exceptions_handling_service/* handleRuntimeError */.s)("ProductPrice: error calculating total price per month. Params: ".concat(JSON.stringify(params)));
    }
    var pricePerSeat = (0,pricing_service/* getCurrencyWithPriceDisplay */.$H)({
        price: totalPricePerMonth.toLocaleString(),
        currency: currency,
        localeId: localeId,
        hideCurrency: splitCurrencySign
    });
    var totalPrice = (0,pricing_service/* getCurrencyWithPriceDisplay */.$H)({
        price: (totalPricePerMonth * seats).toLocaleString(),
        currency: currency,
        localeId: localeId,
        className: "product-price-total"
    });
    var currencySignDisplay = (0,react.useMemo)(function() {
        return (0,pricing_service/* getCurrencySign */.hU)(currency);
    }, [
        currency
    ]);
    var renderUpToSeats = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "product-price-total",
            children: translateOrTranslateWithParam({
                key: "pricingPage.upToXSeats",
                param: (0,monetization_ab_tests_service/* getFreeTierSeatsCountByAbTest */.FW)({
                    cookies: cookies,
                    abTests: abTests,
                    forcePricing: forcePricing
                })
            })
        });
    };
    var renderPricePerMonth = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "product-price-total-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "product-price-total",
                            children: translate("pricingPage.total")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "product-price-total",
                            children: totalPrice
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "product-price-total",
                            children: translate("pricingPage.perMonthSlash")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-price-billed-periodically",
                    children: translate("pricingPage.periods.".concat(period, ".billed"))
                })
            ]
        });
    };
    var renderFreeForever = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                translate("pricingPage.free"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                " ",
                translate("pricingPage.forever")
            ]
        });
    };
    var renderSeatPerMonth = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                translate("pricingPage.seatOver"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                " ",
                translate("pricingPage.month")
            ]
        });
    };
    var shouldSeeFreeForever = (0,react.useMemo)(function() {
        return tierName === pricing/* TIERS.FREE */.Iy.FREE && !hideFreeForever;
    }, [
        hideFreeForever,
        tierName
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductPrice, {
        className: "price",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "price-tag",
                children: [
                    splitCurrencySign && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "currency-sign",
                        children: [
                            currencySignDisplay,
                            (0,pricing_service/* shouldShowCurrencyText */.zD)(currency) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "price-currency-text",
                                children: currency.toUpperCase()
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "amount",
                        children: pricePerSeat
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "price-description",
                        children: [
                            shouldSeeFreeForever && renderFreeForever(),
                            !shouldSeeFreeForever && renderSeatPerMonth()
                        ]
                    })
                ]
            }),
            tierName === pricing/* TIERS.FREE */.Iy.FREE && renderUpToSeats(),
            tierName !== pricing/* TIERS.FREE */.Iy.FREE && renderPricePerMonth(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
        ]
    });
};

// EXTERNAL MODULE: ./services/pricing/pricing-page/contact-us-link-service.js
var contact_us_link_service = __webpack_require__(4442);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./constants/pricing-sizes.js
var pricing_sizes = __webpack_require__(42349);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/prices-and-features-cards-pricing/product-prices-and-features-cards/product-price-and-features-card/product-price-and-features-card.scss.js






var StyledProductPriceAndFeatures = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eeg7e3b0"
})('.horizontal-line{display:block;width:100%;border-bottom:2px solid #c5c7d0;margin:24px 0;}.signup-form-wrapper{input{width:100% !important;min-width:0px !important;}}&.card{min-width:0;flex:1 0 0;border-radius:4px;border:1px solid #d5d5d5;padding:16px;box-shadow:none;display:flex;flex-direction:column;align-items:flex-start;.icons{height:45px;display:flex;.icon{flex-shrink:0;border:solid 1px;border-radius:8px;width:42px;height:42px;padding:4px;margin-right:8px;color:#292f4c;display:flex;justify-content:center;align-items:center;border-color:var(--product-color);}}.tier-title-container{height:50px;align-self:stretch;}.tier-title{margin:8px 0;font-size:1.238rem;color:#333333;letter-spacing:-0.36px;display:flex;align-items:center;position:relative;max-width:calc(100% - 80px);.product-and-tier{& > div{float:left;}}.tier{font-weight:bold;margin-right:4px;}.most-popular-badge-container{flex-grow:1;}.most-popular-badge{font-weight:700;font-size:0.8125rem;line-height:16px;border-radius:4px;width:66px;padding:8px;position:absolute;top:50%;transform:translateY(-50%);margin-left:16px;z-index:2;color:white;&::before{z-index:1;content:"";position:absolute;transform:rotate(45deg);width:14px;height:14px;left:-7px;top:calc(50% - 7px);display:block;}}.most-popular-badge,.most-popular-badge::before{background-color:', function(param) {
    var styleColor = param.styleColor;
    return styleColor;
}, ";}}&.is-most-popular{box-shadow:0px 6px 20px rgba(0,0,0,0.2);.cta-button .ladda-button-component .signup-button,.cta-button .ladda-button-component .cta-button{color:black;}}.contact{height:140px;padding:16px 0;& > div{font-weight:600;}}.cta-button{width:", function(param) {
    var isContactUsCard = param.isContactUsCard, isMobileOrTabletBrowser = param.isMobileOrTabletBrowser;
    return isContactUsCard || !isMobileOrTabletBrowser ? "auto" : "100%";
}, ";&.try-cta-padding{padding-bottom:64px;}padding:0 0 16px 0;.ladda-button-component .signup-button,.ladda-button-component .cta-button{background-color:transparent;border:1px solid black;color:black;letter-spacing:0.4px;*{font-weight:bold;}}.ladda-button-component .signup-button:hover,.ladda-button-component .cta-button:hover{border-color:", function(param) {
    var ctaHoverBorderColor = param.ctaHoverBorderColor;
    return ctaHoverBorderColor;
}, ";background-color:", function(param) {
    var ctaHoverBackgroundColor = param.ctaHoverBackgroundColor;
    return ctaHoverBackgroundColor;
}, ";color:", function(param) {
    var ctaHoverTextColor = param.ctaHoverTextColor;
    return ctaHoverTextColor;
}, ";filter:none;}}.pricing-signup-purchase-now{display:flex;gap:5px;margin-bottom:", pricing_sizes/* CLEAN_FIRST_FOLD_MARGIN */.TR, ";height:20px;}.purchase-now-link{font-weight:bold;text-decoration-line:underline;}.description{font-size:0.875rem;line-height:24px;height:70px;letter-spacing:-0.36px;color:#676879;}.feature{font-size:0.844rem;margin-bottom:24px;display:flex;align-self:stretch;align-items:center;justify-content:space-between;.icon{position:relative;margin-left:6px;.tooltip{z-index:", z_index/* MODAL_BACKGROUND */.AE, ";display:none;opacity:0;position:absolute;bottom:calc(100% + 16px);transform:translateX(-50%);transition:opacity 0.2s ease;width:300px;.floating-tooltip{position:relative;white-space:normal;text-align:left;}}&:hover{.tooltip{display:block;opacity:1;transform:translateX(-24.8%);}}}.name-and-label{display:flex;align-items:center;gap:8px;}}}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.ladda-button-component{.cta-button{.signup-form{input{min-width:240px;}}}}}");
var StyledProductPriceAndFeaturesWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eeg7e3b1"
})("&.card-container{&.is-homepage-pricing{display:flex;flex-direction:column;margin-top:30px;.most-popular{background:", colors/* default */.Z[color_consts.BRAND_DARK_COLOR], ";text-align:center;padding:4px;border-radius:16px 16px 0px 0px;.most-popular-span{color:white;text-align:center;font-size:14px;font-style:normal;font-weight:600;line-height:24px;}}.card{border-radius:16px;margin-top:16px;padding:20px;&.is-most-popular{border-color:var(--primary-color);}.tier-title{max-width:100%;.coming-soon{padding:1px 8px;margin-left:8px;justify-content:center;align-items:center;border:1px solid ", colors/* default.asphalt */.Z.asphalt, ";border-radius:4px;font-size:14px;line-height:22px;}}.amount{font-family:Poppins;font-size:48px;font-style:normal;font-weight:700;letter-spacing:-1px;margin-right:8px;}.price-tag{align-items:center;display:flex;font-size:16px;font-family:Sofia Pro;font-weight:400;}.cta-button{width:100%;border:none;padding:0 0 16px 0;.ladda-button-component .signup-button,.ladda-button-component .cta-button{background-color:var(--primary-color);color:white;letter-spacing:0.4px;max-width:none;width:100%;border:none;padding:12px 12px;&:hover{background-color:var(--secondary-color);}}.ladda-button-component .contact-us-button{border-color:9px solid black;border:1px solid var(--secondary-color);background-color:transparent;color:var(--secondary-color);.ladda-label{font-weight:400;font-size:14px;}&:hover{background-color:var(--secondary-color);color:white;}}.signup-form{display:inherit;width:100%;}.signup-button-wrapper{width:inherit;}.signup-text{font-weight:400;font-size:14px;gap:10px;}}.description{height:70px;font-size:14px;font-style:normal;font-weight:400;line-height:22px;letter-spacing:normal;display:flex;}.info-icon{height:12px;width:12px;}&.is-most-popular{margin-top:0px;padding-top:5px;border-radius:0px 0px 16px 16px;border-top:none;box-shadow:none;}.tier-include{font-size:16px;font-weight:600;margin-bottom:16px;}.tier-learn-more-button{height:32px;display:block;align-self:center;margin-bottom:14px;}.play-wrapper,.secondary-button-text{color:var(--secondary-color);}.feature{.icon{.tooltip{transform:translateX(-25.4%);}}}}.currency-sign{font-size:48px;font-weight:100;}.horizontal-line{width:100%;border-bottom:1px solid;border-color:", colors/* default */.Z[color_consts.GAINSBORO_COLOR_NAME], ";}}}");
var ModalGlobalStyles = new String(".react-modal-overlay{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.5);-webkit-backdrop-filter:blur(5px);backdrop-filter:blur(5px);display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;z-index:1000}.react-modal-content{max-height:85vh;overflow-y:hidden;position:relative;background-color:white;-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;padding:60px 40px 60px 40x;-webkit-box-shadow:0 4px 10px rgba(0,0,0,.1);-moz-box-shadow:0 4px 10px rgba(0,0,0,.1);box-shadow:0 4px 10px rgba(0,0,0,.1);width:auto;max-width:800px;z-index:1001;margin:auto;inset:unset}.get-quote-modal-container{padding:40px 40px 0 40px;max-height:85vh;min-width:640px;overflow-y:auto;.modal-close-icon{justify-self:end;cursor:pointer}.core-title{font-weight:500;font-size:2.5rem}.base-form{margin:0;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}}");
ModalGlobalStyles.__hash = "37be13644c50ea59";

// EXTERNAL MODULE: ./services/ab-tests/acquisition-ab-test-service.js
var acquisition_ab_test_service = __webpack_require__(77784);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./client/services/hubspot-service/contact-form-config.js + 1 modules
var contact_form_config = __webpack_require__(49228);
// EXTERNAL MODULE: ./segments/desktop/core-components/hubspot-contact-form/hubspot-contact-form.js + 2 modules
var hubspot_contact_form = __webpack_require__(78235);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./static/svg/icons/close.svg
var icons_close = __webpack_require__(2002);
;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/prices-and-features-cards-pricing/product-prices-and-features-cards/product-price-and-features-card/consts.js
var maxNoTouchSeats = 50;
var CARD_CLASS = "card";
var DEFAULT_CONTACT_SALES_LINK = "/sales/contact-us?from=pricing&source=Website%20-%20Contact%20Sales";
var THANK_YOU_PAGE = "/contact-sales-thank-you";
var THANK_YOU_PAGE_SB = "/contact-sales-thank-you-sb";
var HS_FROM_FIELD_VALUE = "pricing";

// EXTERNAL MODULE: ./client/services/hubspot-service/hubspot-constants.js
var hubspot_constants = __webpack_require__(22638);
// EXTERNAL MODULE: ./services/localization/localization-service.js
var localization_service = __webpack_require__(99952);
;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/prices-and-features-cards-pricing/product-prices-and-features-cards/product-price-and-features-card/product-price-and-features-card.js
function product_price_and_features_card_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_price_and_features_card_define_property(target, key, source[key]);
        });
    }
    return target;
}













































var ProductPriceAndFeatures = function(param) {
    var productName = param.productName, productId = param.productId, period = param.period, tier = param.tier, previousTierName = param.previousTierName, color = param.color, colorMobile = param.colorMobile, ctaHoverBackgroundColor = param.ctaHoverBackgroundColor, ctaHoverBorderColor = param.ctaHoverBorderColor, ctaHoverTextColor = param.ctaHoverTextColor, primaryColor = param.primaryColor, secondaryColor = param.secondaryColor, seats = param.seats, isMostPopular = param.isMostPopular, abTests = param.abTests, onPurchaseNowClicked = param.onPurchaseNowClicked, hideFreeForever = param.hideFreeForever, isHomepagePricing = param.isHomepagePricing, isApplyMaxDiffFeatures = param.isApplyMaxDiffFeatures, showLearnMoreVideo = param.showLearnMoreVideo, showFreeTierComingSoon = param.showFreeTierComingSoon, labeledTierFeatures = param.labeledTierFeatures, getQuoteModalFullParagraph = param.getQuoteModalFullParagraph, hubspotFromFieldValue = param.hubspotFromFieldValue;
    var _translate;
    var tierName = tier.name, features = tier.features;
    var ref = (0,react.useContext)(generic_config_context/* GenericConfigContext */.Z), translate = ref.translate, forcePricing = ref.forcePricing, translateWithParam = ref.translateWithParam, localeId = ref.localeId, isMobileOrTabletBrowser = ref.isMobileOrTabletBrowser, simulateGetQuoteTextAndModal = ref.simulateGetQuoteTextAndModal;
    var shouldShowPrices = tierName !== pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE && seats < maxNoTouchSeats;
    var canPurchaseNow = (0,monetization_ab_tests_service/* shouldShowPurchaseNow */.u0)({
        abTests: abTests,
        forcePricing: forcePricing
    });
    var isFreeOrEnterprise = [
        pricing/* TIERS.FREE */.Iy.FREE,
        pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE
    ].includes(tierName);
    var ref1 = (0,react.useState)(false), isGetQuotePopupOpen = ref1[0], setGetQuotePopupOpen = ref1[1];
    var shouldShowQuoteTextAndModal = simulateGetQuoteTextAndModal || (0,acquisition_ab_test_service.shouldGetQuoteTextAndModal)(abTests, true);
    var contactUsTranslateKey = shouldShowQuoteTextAndModal ? "pricingPage.get_quote" : "footer.contactSales";
    var contactUsText = translate(contactUsTranslateKey);
    var getQuoteSubmitEvent = {
        eventType: bigbrain_event_types.CONTACT_SALES_POPUP_FORM_SUBMIT,
        data: {
            productKind: productName
        }
    };
    var onPurchaseNowClick = function(e) {
        var currentTarget = e.currentTarget;
        var purchaseNowLinkParent = currentTarget.closest("div.".concat(CARD_CLASS));
        var signupButton = purchaseNowLinkParent.querySelector("button");
        onPurchaseNowClicked({
            tier: tier,
            target: signupButton
        });
    };
    var tierIncludesText = (0,react.useMemo)(function() {
        return !previousTierName ? translateWithParam("pricingPage.tierCards.planIncludes", translate((0,strings.getCapitilizedString)(tier.name))) : translateWithParam("pricingPage.tierCards.includesPlanPlus", translate(previousTierName));
    }, [
        previousTierName,
        translateWithParam,
        tier,
        translate
    ]);
    var getLearnMoreButtonText = function() {
        return translateWithParam("pricingPage.tierCards.learnMoreButton", tier.name);
    };
    var featuresOrMaxDiffFeatures = (0,react.useMemo)(function() {
        if (isHomepagePricing && productName === products/* PLATFORM_PRODUCT_IDS */.xZ[products/* WORK_MANAGEMENT_PRODUCT_ID */.py]) {
            var maxDiffFeatures = tier.maxDiffFeatures;
            return isApplyMaxDiffFeatures && maxDiffFeatures ? maxDiffFeatures : features;
        }
        return features;
    }, [
        features,
        isApplyMaxDiffFeatures,
        isHomepagePricing,
        productName,
        tier
    ]);
    var renderLearnMoreVideoCTAOrPlaceholder = function() {
        var hasVideo = hasLearnMoreVideo(tier.name);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tier-learn-more-button",
            children: hasVideo && showLearnMoreVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube_popup_button/* default */.Z, {
                isWithIcon: true,
                isWithIconInsteadOfArrow: true,
                withoutUnderline: true,
                minPadding: true,
                outline: true,
                isWithArrow: false,
                iconColor: color,
                buttonText: getLearnMoreButtonText(),
                videoId: getVideoIdByLocaleAndTier(localeId, tier.name),
                buttonDisplayType: button_consts/* SECONDARY_BUTTON_TYPE */.jE,
                extraEventData: {
                    buttonName: "hp_pp_tier_learn_more",
                    tier: tier.name,
                    locale: localeId
                }
            })
        });
    };
    var sendHoverEvent = function(feature, eventName) {
        (0,bigbrain_service.trackEvent)(eventName, {
            info1: feature,
            info2: tier.name,
            kind: feature,
            productKind: productName
        });
    };
    var onMouseEnter = function(feature) {
        sendHoverEvent(feature, bigbrain_event_types.PRICING_PAGE_FEATURE_INFO_ICON_HOVER);
    };
    var onMouseLeave = function(feature) {
        sendHoverEvent(feature, bigbrain_event_types.PRICING_PAGE_FEATURE_INFO_ICON_EXIT);
    };
    var onMouseEnterComingSoon = function(feature) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_FREE_TIER_COMING_SOON_HOVER, {
            info2: tier.name,
            productKind: productName
        });
    };
    var showComingSoon = (0,react.useMemo)(function() {
        return showFreeTierComingSoon && tierName === pricing/* TIERS.FREE */.Iy.FREE;
    }, [
        showFreeTierComingSoon,
        tierName
    ]);
    var onContactUsClick = (0,react.useCallback)(function() {
        var _localStorage, _localStorage1;
        (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.setItem(hubspot_constants/* HUBSPOT_CONTACT_SALES_CTA */.Wm, (0,localization_service/* getRawTranslationValue */.RH)(contactUsTranslateKey));
        (_localStorage1 = localStorage) === null || _localStorage1 === void 0 ? void 0 : _localStorage1.setItem(hubspot_constants/* HUBSPOT_CONTACT_SALES_CTA_TRANSLATED */.y8, contactUsText);
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.CONTACT_US_BUTTON_CLICKED, {
            placement: "tier-value-card",
            source: bigbrain_event_types.HP_SOURCE,
            info1: tier.name,
            info2: seats,
            productKind: productName,
            data: {
                buttonText: contactUsText
            }
        });
        if (shouldShowQuoteTextAndModal) {
            setGetQuotePopupOpen(true);
        } else {
            window.location.href = DEFAULT_CONTACT_SALES_LINK;
        }
    }, [
        abTests,
        productName,
        seats,
        tier.name
    ]);
    var closeModal = function() {
        setGetQuotePopupOpen(false);
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.CONTACT_SALES_POPUP_FORM_CLOSE);
    };
    var handleBeforeSubmitCallback = function() {
        (0,cookies_service/* setCookie */.d8)(cookies.HOMEPAGE_PRICING_TIER_SOURCE, "".concat(productName, "-").concat(tierName));
    };
    var productColor = typeof colorMobile === "string" ? colorMobile : color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(utils_react/* ConditionalWrapper */.M, {
        condition: isHomepagePricing,
        wrapper: function(children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductPriceAndFeaturesWrapper, {
                styleColor: isHomepagePricing ? "auto" : color,
                ctaHoverBackgroundColor: ctaHoverBackgroundColor,
                ctaHoverBorderColor: ctaHoverBorderColor,
                ctaHoverTextColor: ctaHoverTextColor,
                isContactUsCard: !shouldShowPrices,
                isMobileOrTabletBrowser: isMobileOrTabletBrowser,
                className: classnames_default()("card-container", {
                    "is-homepage-pricing": isHomepagePricing,
                    "is-most-popular": isMostPopular
                }),
                children: [
                    isHomepagePricing && isMostPopular && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "most-popular",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "most-popular-span",
                            children: translate("pricingPage.mostPopular")
                        })
                    }),
                    children
                ]
            });
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductPriceAndFeatures, {
                styleColor: isHomepagePricing ? "auto" : color,
                ctaHoverBackgroundColor: ctaHoverBackgroundColor,
                ctaHoverBorderColor: ctaHoverBorderColor,
                ctaHoverTextColor: ctaHoverTextColor,
                isContactUsCard: !shouldShowPrices,
                isMobileOrTabletBrowser: isMobileOrTabletBrowser,
                className: classnames_default()(CARD_CLASS, {
                    "is-most-popular": isMostPopular
                }),
                style: {
                    "--primary-color": primaryColor,
                    "--secondary-color": secondaryColor
                },
                children: [
                    !isHomepagePricing && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "icons",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "icon",
                            style: {
                                "--product-color": productColor
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_icon/* ProductIcon */.w, {
                                product: productName
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tier-title-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tier-title",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "product-and-tier",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tier",
                                            children: translate((0,plans_service/* getTierTranslationKey */.OU)(tierName, {
                                                hasStudentPlan: false
                                            }))
                                        }),
                                        isHomepagePricing && showComingSoon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            onMouseEnter: onMouseEnterComingSoon,
                                            className: "coming-soon",
                                            children: translate("pricingPage.comingSoon")
                                        }),
                                        !isHomepagePricing && productName !== products/* PLATFORM_PRODUCT_IDS */.xZ[products/* WORK_MANAGEMENT_PRODUCT_ID */.py] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: translate("pricingPage.products.".concat(productName, ".title"))
                                        })
                                    ]
                                }),
                                !isHomepagePricing && isMostPopular && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "most-popular-badge-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "most-popular-badge",
                                        children: translate("pricingPage.mostPopular")
                                    })
                                })
                            ]
                        })
                    }),
                    shouldShowPrices ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice, {
                        product: productName,
                        period: period,
                        seats: seats,
                        tierName: tierName,
                        hideFreeForever: hideFreeForever,
                        splitCurrencySign: isHomepagePricing
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "contact",
                        children: isHomepagePricing ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing_enterprise_icon, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactUsIcon, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("cta-button", {
                            "try-cta-padding": canPurchaseNow && isFreeOrEnterprise,
                            "contact-us": !shouldShowPrices
                        }),
                        children: shouldShowPrices ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "signup-form-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {
                                className: "signup-form",
                                ctaText: translate("signup.tryForFree"),
                                buttonSize: "xs",
                                forceInputHide: true,
                                useCtaText: true,
                                buttonSpinnerColor: colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR],
                                pricingDetails: {
                                    tier: tierName,
                                    userCount: seats,
                                    billingPeriod: period,
                                    product: productName
                                },
                                signupProductId: productId,
                                extraData: {
                                    pricing_tier: tierName,
                                    cta_name: "tier_cards"
                                },
                                beforeSubmitCallback: handleBeforeSubmitCallback
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(button_component/* default */.Z, {
                            className: classnames_default()("cta-button", "contact-us-button"),
                            type: "button",
                            size: "xs",
                            onClickCallback: onContactUsClick,
                            children: contactUsText
                        })
                    }),
                    canPurchaseNow && !isFreeOrEnterprise && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pricing-signup-purchase-now",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: (_translate = translate("signup.or")) === null || _translate === void 0 ? void 0 : _translate.toLowerCase()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "purchase-now-link",
                                onClick: onPurchaseNowClick,
                                children: translate("pricingPage.purchaseNow")
                            })
                        ]
                    }),
                    isHomepagePricing && renderLearnMoreVideoCTAOrPlaceholder(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "description",
                        children: translate("pricingPage.products.".concat(productName, ".tiers.").concat(tier.name, ".description"))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "horizontal-line"
                    }),
                    isHomepagePricing && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tier-include",
                        children: tierIncludesText
                    }),
                    featuresOrMaxDiffFeatures === null || featuresOrMaxDiffFeatures === void 0 ? void 0 : featuresOrMaxDiffFeatures.map(function(feature) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "feature",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "name-and-label",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            dangerouslySetInnerHTML: {
                                                __html: translate("pricingPage.products.".concat(productName, ".tiers.").concat(tierName, ".features.").concat(feature))
                                            }
                                        }),
                                        labeledTierFeatures[feature] && /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* default */.Z, {
                                            text: translate(labeledTierFeatures[feature]),
                                            borderColor: "blue"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "icon",
                                    onMouseEnter: function() {
                                        return onMouseEnter(feature);
                                    },
                                    onMouseLeave: function() {
                                        return onMouseLeave(feature);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tooltip",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_component/* default */.Z, {
                                                theme: tooltip_constants.DARK_THEME,
                                                className: "floating-tooltip",
                                                children: translate("pricingPage.products.".concat(productName, ".tiers.").concat(tierName, ".features.").concat(feature, ".description"))
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing_info_icon/* default */.Z, {
                                            className: "info-icon"
                                        })
                                    ]
                                })
                            ]
                        });
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((lib_default()), {
                isOpen: isGetQuotePopupOpen,
                overlayClassName: "react-modal-overlay",
                className: "react-modal-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-".concat(ModalGlobalStyles.__hash) + " " + "get-quote-modal-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: closeModal,
                                className: "jsx-".concat(ModalGlobalStyles.__hash) + " " + "modal-close-icon",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_close/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, _object_spread({}, getQuoteModalFullParagraph)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(hubspot_contact_form/* default */.Z, {
                                formId: contact_form_config/* CONTACT_SALES_HUBSPOT_FORM_ID */.PD,
                                urlToRedirectAfterSubmission: THANK_YOU_PAGE,
                                urlToRedirectAfterSubmissionForSmallBusinesses: THANK_YOU_PAGE_SB,
                                dontRenderPostFormSubmit: true,
                                hubspotFromHiddenField: hubspotFromFieldValue,
                                externalEventsForSubmit: getQuoteSubmitEvent,
                                isV2: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                        id: ModalGlobalStyles.__hash,
                        children: ModalGlobalStyles
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var product_price_and_features_card = ((0,ab_tests_context/* withAbTests */.k)(ProductPriceAndFeatures));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.browser.esm.js + 13 modules
var react_select_browser_esm = __webpack_require__(16455);
;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/prices-and-features-cards-pricing/product-prices-and-features-cards/users-select/users-select-component.scss.js

var StyledUsersSelect = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e16er9610"
})("display:flex;align-items:center;font-size:0.875rem;.billing-users-selection{margin-left:12px;min-width:190px;z-index:10;}");

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/prices-and-features-cards-pricing/product-prices-and-features-cards/users-select/users-select-component.js








var UsersSelect = function(param) {
    var usersCountArray = param.usersCountArray, updateSelectedUserCountCallback = param.updateSelectedUserCountCallback, productName = param.productName, defaultSeatsIndex = param.defaultSeatsIndex;
    var selectRef = (0,react.useRef)(null);
    var translate = (0,react.useContext)(generic_config_context/* GenericConfigContext */.Z).translate;
    var options = (0,react.useMemo)(function() {
        return Object.entries(usersCountArray).map(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), label = _param[0], value = _param[1];
            return {
                label: "".concat(label, " ").concat(translate("pricingPage.seats")),
                value: value
            };
        });
    }, [
        usersCountArray,
        translate
    ]);
    var onFocus = (0,react.useCallback)(function() {
        var _selectRef_current_state_value, _selectRef_current_state, _selectRef_current;
        var selectedOption = selectRef === null || selectRef === void 0 ? void 0 : (_selectRef_current = selectRef.current) === null || _selectRef_current === void 0 ? void 0 : (_selectRef_current_state = _selectRef_current.state) === null || _selectRef_current_state === void 0 ? void 0 : (_selectRef_current_state_value = _selectRef_current_state.value) === null || _selectRef_current_state_value === void 0 ? void 0 : _selectRef_current_state_value.value;
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_SEAT_DROPDOWN_OPENED, {
            info2: selectedOption,
            productKind: productName
        });
    }, [
        productName
    ]);
    var onSelectionChange = (0,react.useCallback)(function(param) {
        var value = param.value;
        updateSelectedUserCountCallback(value);
    }, [
        updateSelectedUserCountCallback
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledUsersSelect, {
        className: "users-select",
        children: [
            translate("pricingPage.chooseTeamSize"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_browser_esm/* default */.ZP, {
                ref: selectRef,
                name: "billing-users-selection",
                className: "billing-users-selection",
                isClearable: false,
                isSearchable: false,
                onChange: onSelectionChange,
                defaultValue: options[defaultSeatsIndex],
                options: options,
                "aria-labelledby": "usersSelectLabel",
                onFocus: onFocus
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/prices-and-features-cards-pricing/product-prices-and-features-cards/period-select/period-select-component.scss.js

var StyledPeriodSelect = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1qb58m80"
})("font-size:0.875rem;display:flex;align-items:center;column-gap:10px;color:#333333;.period{cursor:pointer;&.selected{cursor:default;color:#4353ff;&.is-homepage-pricing{color:var(--primary-color);font-weight:700;}}}");

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/prices-and-features-cards-pricing/product-prices-and-features-cards/period-select/period-select-component.js





var PeriodSelect = function(param) {
    var onPeriodChange = param.onPeriodChange, primaryColor = param.primaryColor, isHomepagePricing = param.isHomepagePricing;
    var ref = (0,react.useState)("yearly"), period = ref[0], setPeriod = ref[1];
    var translate = (0,react.useContext)(generic_config_context/* GenericConfigContext */.Z).translate;
    var handlePeriodChange = (0,react.useCallback)(function(newPeriod) {
        setPeriod(newPeriod);
        onPeriodChange(newPeriod);
    }, [
        onPeriodChange
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPeriodSelect, {
        className: "periodSelect",
        style: {
            "--primary-color": primaryColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("period", {
                    selected: period === "yearly",
                    "is-homepage-pricing": isHomepagePricing
                }),
                onClick: function() {
                    handlePeriodChange("yearly");
                },
                children: [
                    translate("pricingPage.periods.yearly.displayNameShort"),
                    " ",
                    translate("pricingPage.periods.save")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "|"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("period", {
                    selected: period === "monthly",
                    "is-homepage-pricing": isHomepagePricing
                }),
                onClick: function() {
                    handlePeriodChange("monthly");
                },
                children: translate("pricingPage.periods.monthly.displayName")
            })
        ]
    });
};

;// CONCATENATED MODULE: ./static/svg/clap.svg
var clap_path, clap_path2, clap_path3, clap_path4, clap_path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g2, _path28, _path29, _path30, _defs;
function clap_extends() {
    clap_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return clap_extends.apply(this, arguments);
}

var SvgClap = function SvgClap(props) {
    return /*#__PURE__*/ react.createElement("svg", clap_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 181,
        height: 127,
        fill: "none",
        viewBox: "0 0 181 127"
    }, props), clap_path || (clap_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: 5.782,
        d: "M87.066 77.218c-2.767 3.579-10.862 1.905-18.086-3.734-7.25-5.64-10.862-13.107-8.12-16.686"
    })), clap_path2 || (clap_path2 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint0_linear_1578_14470)",
        d: "M104.51 39.032s3.637.72 5.097.49c1.461-.233 3.612-.49 3.612-.49s.231-14.085.257-18.257c.025-4.171 0-10.12 0-10.943s-.487-2.447-2.665-2.19-5.559 2.19-5.559 7.803.231 7.313.231 9.013c0 1.699-2.177 11.432-2.177 11.432l-.487 2.678z"
    })), clap_path3 || (clap_path3 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint1_linear_1578_14470)",
        d: "M98.568 9.445a1.09 1.09 0 0 0-1.076-1.005c-1.23-.025-3.33.31-4.612 2.601-1.946 3.4-.204 12.67-.204 14.369 0 1.596-.538 9.012-.718 9.913 0 .052-.999.103-.948.129.462.18 2.665 1.03 4.483.515 1.845-.515 4.637-2.008 5.098-2.24.051-.026.077-.077.051-.103z"
    })), clap_path4 || (clap_path4 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint2_linear_1578_14470)",
        d: "M108.148 34.242s-.487-17.098-.718-21.012c-.23-3.888 0-9.862 0-10.223 0-.36-.973-1.957-2.894-2.188-1.947-.232-4.483 2.188-4.842 5.124 0 0-1.204 15.578-.973 16.789.23 1.21-1.46 11.278-1.46 11.278s.973 1.159 4.611 1.39c3.612.232 6.276-1.158 6.276-1.158"
    })), clap_path5 || (clap_path5 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint3_linear_1578_14470)",
        d: "M108.148 34.242s-.487-17.098-.718-21.012c-.23-3.888 0-9.862 0-10.223 0-.36-.973-1.957-2.894-2.188-1.947-.232-4.483 2.188-4.842 5.124 0 0-1.204 15.578-.973 16.789.23 1.21-1.46 11.278-1.46 11.278s.973 1.159 4.611 1.39c3.612.232 6.276-1.158 6.276-1.158"
    })), _path6 || (_path6 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint4_linear_1578_14470)",
        d: "M104.51 39.032s3.637.72 5.097.49c1.461-.233 3.612-.49 3.612-.49s.231-14.085.257-18.257c.025-4.171 0-10.12 0-10.943s-.487-2.447-2.665-2.19-5.559 2.19-5.559 7.803.231 7.313.231 9.013c0 1.699-2.177 11.432-2.177 11.432l-.487 2.678z"
    })), _path7 || (_path7 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint5_linear_1578_14470)",
        d: "M96.286 66.79s-4.842 1.7-7.276 0c-2.433-1.7-5.328-3.889-4.61-11.69.717-7.803 1.716-7.494 1.716-12.592s.486-7.082.486-7.082 10.631-1.982 14.039-1.725c3.381.232 11.63 3.167 11.63 3.167l-.487 21.553-2.792 10.274z"
    })), _path8 || (_path8 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint6_linear_1578_14470)",
        d: "M110.683 60.841c2.177-.18 7.275-2.678 7.275-7.802V23.324s-1.204-2.318-3.868-2.19c-2.664.13-7.993 3.168-4.611 16.79 0 0-9.683 5.356-9.453 12.411.256 7.081 4.611 10.995 10.657 10.506"
    })), _path9 || (_path9 = /*#__PURE__*/ react.createElement("path", {
        fill: "#BF5968",
        d: "M93.006 26.517s-.359-4.455-.41-5.742c-.103-2.034-4.304-3.502-4.919.386S86.473 33.315 86.5 36.74c.026 3.424 5.303 1.236 5.303 1.236z"
    })), _path10 || (_path10 = /*#__PURE__*/ react.createElement("path", {
        fill: "#A72E40",
        d: "M89.803 38.928s9.222-3.605 18.701-.515c0 0-9.479-4.12-18.7.515"
    })), _path11 || (_path11 = /*#__PURE__*/ react.createElement("path", {
        fill: "#FC0",
        d: "M155.663 101.52c9.695-14.338 9.737-31.301.094-37.888-9.642-6.587-25.317-.303-35.011 14.035s-9.737 31.301-.094 37.888c9.642 6.587 25.317.303 35.011-14.035M175.366 67.381c3.042 0 5.508-2.479 5.508-5.536 0-3.058-2.466-5.536-5.508-5.536s-5.507 2.478-5.507 5.536 2.466 5.536 5.507 5.536"
    })), _path12 || (_path12 = /*#__PURE__*/ react.createElement("path", {
        fill: "#F36",
        d: "m170.09 37.588-4.329 6.386c-.666 1.004-.41 2.369.589 3.039s2.357.412 3.023-.593l4.329-6.386c.666-1.004.41-2.369-.589-3.038a2.173 2.173 0 0 0-3.023.592"
    })), /*#__PURE__*/ react.createElement("mask", {
        id: "mask0_1578_14470",
        width: 75,
        height: 80,
        x: 87,
        y: 39,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path13 || (_path13 = /*#__PURE__*/ react.createElement("path", {
        fill: "#FC0",
        d: "M155.663 101.52c9.694-14.338 12.883-32.111-31.686-59.408-9.642-6.587-25.317-.303-35.011 14.035s22.043 52.821 31.685 59.408 25.318.303 35.012-14.035"
    }))), _g || (_g = /*#__PURE__*/ react.createElement("g", {
        mask: "url(#mask0_1578_14470)"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#0F1048",
        d: "M137.578 71.5s-3.56-5.51-4.739-5.716c-1.153-.206-12.168 1.597-15.754 4.687s-12.732 13.673-13.654 16.222-.948 4.635 4.431 5.408c5.38.772 27.411-9.013 27.411-9.013z"
    }), /*#__PURE__*/ react.createElement("path", {
        stroke: "#fff",
        strokeMiterlimit: 10,
        strokeWidth: 2.577,
        d: "M122.463 83.53c8.453-6.563 13.63-14.064 11.563-16.754s-10.595.45-19.049 7.014c-8.453 6.563-13.63 14.065-11.563 16.755s10.595-.45 19.049-7.014Z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint7_linear_1578_14470)",
        d: "M132.84 72.145s-10.657-11.201-11.861-12.67c-1.204-1.467-2.664-1.699-3.151-7.312-.486-5.588-14.038 2.91-14.038 2.91s-15.985 8.034-12.604 12.411c3.382 4.378 18.419 21.656 18.419 21.656s10.17-.721 15.755-5.846c5.559-5.124 7.505-10.814 7.505-10.814"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#fff",
        d: "m108.377 90.402-5.559-5.588c-.717-.721.487-2.446.487-2.446l1.46 1.467s7.506 0 15.498-6.334c7.993-6.335 7.993-10.223 7.993-10.223l-.487-1.468s.717-.231 1.691.49c.973.72 3.381 3.399 3.381 3.399l5.329 4.866-9.197 12.901-15.268 6.566z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint8_linear_1578_14470)",
        d: "m168.216 100.933-34.147-34.324s2.177 5.587-8.223 14.11-17.471 11.69-21.57 9.991l30.997 33.604c0-.026 17.676 2.42 32.943-23.381"
    }), /*#__PURE__*/ react.createElement("path", {
        stroke: "#fff",
        strokeMiterlimit: 10,
        strokeWidth: 2.577,
        d: "M103.433 90.298c2.075 2.678 10.58-.464 19.034-7.004s13.628-14.06 11.553-16.737"
    }), /*#__PURE__*/ react.createElement("path", {
        stroke: "#fff",
        strokeMiterlimit: 10,
        strokeWidth: 3.029,
        d: "M119.853 103.302a2.26 2.26 0 0 0 2.254-2.266 2.26 2.26 0 0 0-2.254-2.266 2.26 2.26 0 0 0-2.254 2.266 2.26 2.26 0 0 0 2.254 2.266Z"
    }), /*#__PURE__*/ react.createElement("path", {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: 4.543,
        d: "M120.416 109.096s9.094.901 20.211-8.755c9.351-8.111 10.657-16.609 10.529-16.738"
    }))), _path14 || (_path14 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint9_linear_1578_14470)",
        d: "M120.795 77.683c-9.709 14.343-9.734 31.312-.077 37.904s25.336.309 35.019-14.034 9.735-31.311.077-37.903-25.335-.31-35.019 14.033"
    })), _path15 || (_path15 = /*#__PURE__*/ react.createElement("path", {
        fill: "#00CC6F",
        d: "m41.364 58.189 13.987 18.514 23.132.772L65.29 96.607l6.405 22.325-22.16-6.695-19.16 13.03-.513-23.252-18.24-14.291 21.826-7.674zM14.62 122.486c4.244 0 7.685-3.459 7.685-7.725 0-4.267-3.44-7.725-7.685-7.725s-7.685 3.458-7.685 7.725 3.44 7.725 7.685 7.725"
    })), _path16 || (_path16 = /*#__PURE__*/ react.createElement("path", {
        fill: "#F36",
        d: "M3.091 104.718a3.08 3.08 0 0 0 3.074-3.089 3.08 3.08 0 0 0-3.074-3.09 3.08 3.08 0 0 0-3.074 3.09 3.08 3.08 0 0 0 3.074 3.089"
    })), _path17 || (_path17 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint10_linear_1578_14470)",
        d: "m68.803 34.035.512-17.768s4.355-2.317 5.123 2.575c.769 4.893.769 13.648.769 13.648s-2.818 4.377-6.404 1.544"
    })), _path18 || (_path18 = /*#__PURE__*/ react.createElement("path", {
        fill: "#FEC2CA",
        d: "M83.532 52.703c0 4.12 1.28 11.33 7.172 11.072 5.893-.257 9.94-6.695 10.504-11.072.563-4.378 1.793-16.737 2.817-21.115 1.025-4.377 1.537-8.497-1.537-9.785-3.074-1.287-5.891 4.893-6.66 9.013s-1.793 10.815-4.355 13.132-7.941 6.438-7.941 8.755"
    })), _path19 || (_path19 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint11_linear_1578_14470)",
        d: "m73.542 28.24 1.485-23.354c.026-.515.436-.953.948-1.004 1.512-.18 4.509-.13 5.252 2.729 1.024 3.863 0 23.098 0 23.098s-3.843 3.682-7.686-1.468"
    })), _path20 || (_path20 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint12_linear_1578_14470)",
        d: "M79.175 30.816S80.455 1.204 80.968.689c.564-.567 7.429-1.545 7.429 5.922 0 7.468-.769 28.325-.769 28.325s-5.635 2.833-8.453-4.12"
    })), _path21 || (_path21 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint13_linear_1578_14470)",
        d: "M86.605 32.618s.769-25.234 1.025-26.522 5.892-1.287 7.429 4.12c1.537 5.408.768 21.372 0 25.75-.769 4.377-5.892 4.12-5.892 4.12s-2.818-1.03-2.562-7.468"
    })), _path22 || (_path22 = /*#__PURE__*/ react.createElement("path", {
        fill: "#FEC2CA",
        d: "M94.16 57.75s-5.046 10.326-18.06 4.481c-11.476-5.15-10.477-10.016-9.222-13.57.18-.49.359-.927.512-1.365 1.281-3.605 1.486-15.784 1.486-15.784s1.076-3.528 5.687-3.528 16.702 8.034 16.702 8.034l5.431-.515z"
    })), _path23 || (_path23 = /*#__PURE__*/ react.createElement("path", {
        fill: "#FEC2CA",
        d: "M63.985 54.223s2.305-3.528 3.1-6.129c0 0 .998 3.013 0 4.326-.974 1.313-3.1 1.803-3.1 1.803"
    })), /*#__PURE__*/ react.createElement("mask", {
        id: "mask1_1578_14470",
        width: 91,
        height: 82,
        x: 11,
        y: 44,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path24 || (_path24 = /*#__PURE__*/ react.createElement("path", {
        fill: "#00CC6F",
        d: "m41.364 58.188 30.33-14.187 29.317 26.274-30.951 30.049 1.635 18.608-22.16-6.695-19.16 13.03-.513-23.253-18.24-14.29 21.826-7.674z"
    }))), /*#__PURE__*/ react.createElement("g", {
        mask: "url(#mask1_1578_14470)"
    }, _path25 || (_path25 = /*#__PURE__*/ react.createElement("path", {
        fill: "#FEC2CA",
        d: "m10.263 112.443 56.358-60.77s8.71-4.12 15.37 0 7.173 11.33 7.173 11.33L32.55 135.875s-18.956-.772-22.287-23.432"
    })), _path26 || (_path26 = /*#__PURE__*/ react.createElement("path", {
        fill: "#0F1048",
        d: "m37.673 132.167.359-.438 44.983-55.697s-1.793-9.012-10.247-14.934c-8.453-5.923-14.858-2.833-14.858-2.833l-45.854 48.152 8.71 20.858"
    })), /*#__PURE__*/ react.createElement("mask", {
        id: "mask2_1578_14470",
        width: 72,
        height: 76,
        x: 12,
        y: 57,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path27 || (_path27 = /*#__PURE__*/ react.createElement("path", {
        fill: "#0F1048",
        d: "m37.673 132.168.359-.438 44.983-55.697s-1.793-9.012-10.247-14.935c-8.453-5.922-14.858-2.832-14.858-2.832l-45.854 48.152 8.71 20.857"
    }))), _g2 || (_g2 = /*#__PURE__*/ react.createElement("g", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: 29.076,
        mask: "url(#mask2_1578_14470)"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M55.094 97.405s.768-4.274-1.281-6.18M65.34 88.393s3.586 4.12 3.586 7.21M80.453 83.758s1.793-4.893-3.33-8.24M61.243 78.608s3.842-1.03 5.892-5.15M64.185 52.935l-.256 9.657M49.38 57.467s-.922 6.464 2.408 7.494M46.1 76.033l4.662.438M45.332 86.076s-3.56 2.06-3.304 5.407M39.21 100.753s2.792.952 2.792 5.51M13.209 110.898s1.23 2.704-2.024 5.846M16.41 131.035s-1.768-2.369.768-6.128M62.267 108.22h-9.325M23.07 86.849s6.148-.515 9.222 1.03M45.332 121.919s-3.048-3.373-5.61-4.918M24.095 112.598s4.226-.515 5.84 0M28.552 100.752s-3.92-.772-8.275 1.03M33.832 126.76s-.41-3.605-7.429-3.605"
    })))), _path28 || (_path28 = /*#__PURE__*/ react.createElement("path", {
        fill: "url(#paint14_linear_1578_14470)",
        d: "m41.34 58.2 13.987 18.514 23.133.773-13.193 19.132 6.404 22.325-22.159-6.695-19.161 13.029-.512-23.252-18.24-14.291 21.826-7.674z"
    })), _path29 || (_path29 = /*#__PURE__*/ react.createElement("path", {
        stroke: "#6C6CFF",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: 5.782,
        d: "M60.857 56.824c2.766-3.58 10.861-1.905 18.085 3.734 7.25 5.639 10.862 13.106 8.121 16.686"
    })), _path30 || (_path30 = /*#__PURE__*/ react.createElement("path", {
        fill: "#F36",
        d: "M80.431 6.38s2.05-.953 2.332-2.55c.281-1.596 0-2.574 0-2.574S81.738.432 80.969.689zM74.794 9.701s1.947-.9 2.203-2.42 0-2.446 0-2.446-.948-.799-1.69-.541zM69.054 20.697s1.691-.902 1.845-2.163c.128-1.288-.18-2.009-.18-2.009s-.922-.592-1.562-.335zM87.294 11.864s2.075-1.107 2.254-2.73c.18-1.622-.205-2.549-.205-2.549s-1.127-.746-1.921-.437zM102.23 27.984c1.665.077 2.075-.85 2.305-1.751.231-.901 0-2.961 0-2.961s-2.408-.824-2.92-.284c-.487.515-2.126 4.867.615 4.996"
    })), _defs || (_defs = /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint0_linear_1578_14470",
        x1: 110.322,
        x2: 108.487,
        y1: 13.74,
        y2: 33.517,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.285,
        stopColor: "#BF5968"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#B03F50"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint1_linear_1578_14470",
        x1: 95.3,
        x2: 95.969,
        y1: 20.929,
        y2: 38.498,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.285,
        stopColor: "#BF5968"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#B03F50"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint2_linear_1578_14470",
        x1: 102.202,
        x2: 102.87,
        y1: 14.071,
        y2: 35.999,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.285,
        stopColor: "#BF5968"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#B03F50"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint3_linear_1578_14470",
        x1: 106.468,
        x2: 95.82,
        y1: 18.928,
        y2: 16.559,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.275,
        stopColor: "#BF5968",
        stopOpacity: 0
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#E67F68"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint4_linear_1578_14470",
        x1: 110.953,
        x2: 102.224,
        y1: 23.828,
        y2: 22.381,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.275,
        stopColor: "#BF5968",
        stopOpacity: 0
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#E67F68"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint5_linear_1578_14470",
        x1: 86.748,
        x2: 113.493,
        y1: 55.478,
        y2: 47.258,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.285,
        stopColor: "#BF5968"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#B03F50"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint6_linear_1578_14470",
        x1: 114.114,
        x2: 98.682,
        y1: 43.532,
        y2: 31.35,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.285,
        stopColor: "#BF5968"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#E67F68"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint7_linear_1578_14470",
        x1: 105.721,
        x2: 124.123,
        y1: 66.996,
        y2: 73.976,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.285,
        stopColor: "#BF5968"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#B03F50"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint8_linear_1578_14470",
        x1: 110.772,
        x2: 130.28,
        y1: 117.361,
        y2: 102.706,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        stopColor: "#fff"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#6C6CFF"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint9_linear_1578_14470",
        x1: 136.458,
        x2: 142.774,
        y1: 77.372,
        y2: 119.907,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.641,
        stopColor: "#FC0",
        stopOpacity: 0
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#FC0"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint10_linear_1578_14470",
        x1: 72.169,
        x2: 77.201,
        y1: 24.974,
        y2: 22.866,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.285,
        stopColor: "#FEC2CA"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#FF97A9"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint11_linear_1578_14470",
        x1: 73.665,
        x2: 84.115,
        y1: 18.199,
        y2: 15.962,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.285,
        stopColor: "#FEC2CA"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#FF97A9"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint12_linear_1578_14470",
        x1: 81.603,
        x2: 90.825,
        y1: 17.905,
        y2: 17.905,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.285,
        stopColor: "#FEC2CA"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#FF97A9"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint13_linear_1578_14470",
        x1: 89.776,
        x2: 100.618,
        y1: 22.723,
        y2: 22.328,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.285,
        stopColor: "#FEC2CA"
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#FF97A9"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "paint14_linear_1578_14470",
        x1: 54.63,
        x2: 26.143,
        y1: 90.221,
        y2: 114.994,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ react.createElement("stop", {
        offset: 0.641,
        stopColor: "#00CC6F",
        stopOpacity: 0
    }), /*#__PURE__*/ react.createElement("stop", {
        offset: 1,
        stopColor: "#00CC6F"
    })))));
};
/* harmony default export */ var clap = (SvgClap);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/monday-ui-react-core/dist/LinearProgressBar.css
var LinearProgressBar = __webpack_require__(20916);
;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/prices-and-features-cards-pricing/components/progress-bar-interval-component/progress-bar-interval-component.js




var progress_bar_interval_component_LinearProgressBar = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9161).then(__webpack_require__.t.bind(__webpack_require__, 89161, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89161)
            ];
        }
    },
    ssr: false
});
var ProgressBarIntervalComponent = function(param) {
    var maxValue = param.maxValue;
    var timer;
    var ref = (0,react.useState)(1), count = ref[0], setCount = ref[1];
    var updateCount = function() {
        timer = setInterval(function() {
            if (count >= maxValue) {
                clearInterval(timer);
            } else {
                setCount(function(prevCount) {
                    return prevCount + 0.01;
                });
            }
        }, 10);
    };
    (0,react.useEffect)(function() {
        updateCount();
        return function() {
            return clearInterval(timer);
        };
    }, [
        count
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(progress_bar_interval_component_LinearProgressBar, {
        className: "linear-progress-bar_small-wrapper progress-bar",
        size: "small",
        value: count,
        max: maxValue
    });
};
/* harmony default export */ var progress_bar_interval_component = (ProgressBarIntervalComponent);

// EXTERNAL MODULE: ./node_modules/monday-ui-react-core/dist/DialogContentContainer.css
var DialogContentContainer = __webpack_require__(59836);
;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/prices-and-features-cards-pricing/components/purchase-now-modal/purchase-now-modal.scss.js




var StyledPurchaseNowModal = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evw425v0"
})("position:absolute;display:flex;width:inherit;justify-content:center;.overlay{background-color:", colors/* default */.Z[color_consts.REACT_MODAL_BACKGROUND_COLOR_NAME], ";opacity:0.7;top:0;left:0;position:fixed;width:100%;height:100%;filter:opacity(0.5);z-index:1000;}.purchase-now-dialog{width:550px;height:400px;position:relative;z-index:1001;align-items:center;display:flex;justify-content:center;display:flex;flex-direction:column;gap:20px;.title{font-weight:400;font-size:1.688rem;line-height:24px;text-align:center;}.subtitle{font-weight:400;font-size:0.875rem;line-height:24px;text-align:center;}.progress-bar{margin-top:45px;width:240px;}}");

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/prices-and-features-cards-pricing/components/purchase-now-modal/purchase-now-modal.js
var _this = undefined;









var purchase_now_modal_DialogContentContainer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3153).then(__webpack_require__.t.bind(__webpack_require__, 93153, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93153)
            ];
        }
    },
    ssr: false
});
var PURCHASE_NOW_REDIRECT_SECONDS = 7;
var PurchaseNowModal = function(param) {
    var isOpen = param.isOpen, signupButton = param.signupButton;
    var translate = (0,react.useContext)(generic_config_context/* GenericConfigContext */.Z).translate;
    (0,react.useEffect)(function() {
        if (isOpen) {
            setTimeout(redirectToSingUp.bind(_this, signupButton), PURCHASE_NOW_REDIRECT_SECONDS * 1000);
        }
    }, [
        isOpen
    ]);
    var redirectToSingUp = function() {
        if ((signupButton === null || signupButton === void 0 ? void 0 : signupButton.type) === "button") {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_PURCHASE_NOW_REDIRECT);
            signupButton.click();
        } else {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_PURCHASE_NOW_REDIRECT_FAILURE);
        }
    };
    if (!isOpen) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPurchaseNowModal, {
        className: "purchase-dialog-wrapper",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "overlay"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(purchase_now_modal_DialogContentContainer, {
                type: "modal",
                className: "purchase-now-dialog",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(clap, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title",
                        children: translate("pricingPage.purchaseNow.modal.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "subtitle",
                        dangerouslySetInnerHTML: {
                            __html: translate("pricingPage.purchaseNow.modal.subtitle")
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(progress_bar_interval_component, {
                        maxValue: PURCHASE_NOW_REDIRECT_SECONDS,
                        className: "progress-bar"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var purchase_now_modal = (PurchaseNowModal);

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./services/pricing/pricing-page/clusterized-pricing-page-service.js + 5 modules
var clusterized_pricing_page_service = __webpack_require__(69017);
;// CONCATENATED MODULE: ./services/pricing/pricing-page/most-popular-service.js



var MIN_BUCKET_SIZE_TO_RECOMMEND_PRO = 10;
var MIN_BUCKET_SIZE_TO_RECOMMEND_ENTERPRISE = 40;
var getMostPopularTierByBucketSize = function(userCount, plans) {
    var realUserCount = parseInt(userCount);
    if (realUserCount >= MIN_BUCKET_SIZE_TO_RECOMMEND_ENTERPRISE) {
        return pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE;
    }
    if (!plans.find(function(param) {
        var tier = param.tier;
        return tier === pricing/* TIERS.STANDARD */.Iy.STANDARD;
    })) {
        return pricing/* TIERS.PRO */.Iy.PRO;
    }
    return realUserCount >= MIN_BUCKET_SIZE_TO_RECOMMEND_PRO ? pricing/* TIERS.PRO */.Iy.PRO : pricing/* TIERS.STANDARD */.Iy.STANDARD;
};
var getClusterMostPopularConfig = function(clusterConfig, abTests, cookies, forcePricing) {
    var _clusterConfig_payments_view_pricing, _clusterConfig_payments_view;
    var mostPopular = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : (_clusterConfig_payments_view_pricing = _clusterConfig_payments_view.pricing) === null || _clusterConfig_payments_view_pricing === void 0 ? void 0 : _clusterConfig_payments_view_pricing.most_popular;
    if (!isEmpty_default()(mostPopular) && (0,clusterized_pricing_page_service/* isInClusterTest */.dn)(clusterConfig, {
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    })) {
        return mostPopular;
    }
    return {};
};
var getMostPopularTierAndText = function(userCount, plans, clusterConfig, abTests, cookies, forcePricing) {
    var clusterMostPopularConfig = getClusterMostPopularConfig(clusterConfig, abTests, cookies, forcePricing);
    var forcedTier = clusterMostPopularConfig.forced_tier, textForForcedTier = clusterMostPopularConfig.text_for_forced_tier, minimumUsersCount = clusterMostPopularConfig.minimum_users_count;
    var mostPopularTier = forcedTier || getMostPopularTierByBucketSize(userCount, plans);
    return {
        tier: mostPopularTier,
        text: forcedTier && textForForcedTier ? textForForcedTier : "pricingPage.mostPopular",
        minimumUsersCount: minimumUsersCount
    };
};

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/prices-and-features-cards-pricing/product-prices-and-features-cards/product-prices-and-features-cards-component.scss.js


var calcMinWidth = function(cardWidth, numberOfTiers) {
    return "calc(".concat(cardWidth, "px * ").concat(numberOfTiers, " + 16px * ").concat(numberOfTiers - 1, ")");
};
var PAGE_WIDTH_1440_CARD_WIDTH = 240;
var PAGE_WIDTH_1920_CARD_WIDTH = 304;
var old_calcMinWidth1440 = "calc(".concat(PAGE_WIDTH_1440_CARD_WIDTH, "px * 5 + 16px * 4)");
var old_calcMinWidth1920 = "calc(".concat(PAGE_WIDTH_1920_CARD_WIDTH, "px * 5 + 16px * 4)");
var calcMinWidth1440 = function(numberOfTiers) {
    return calcMinWidth(PAGE_WIDTH_1440_CARD_WIDTH, numberOfTiers);
};
var calcMinWidth1920 = function(numberOfTiers) {
    return calcMinWidth(PAGE_WIDTH_1920_CARD_WIDTH, numberOfTiers);
};
var StyledProductPriceAndFeaturesCards = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1uabknu0"
})("width:calc(216px * 5 + 16px * 4);max-width:calc(100% - 32px);padding:32px 0;display:flex;flex-direction:column;margin:0 auto;.seats-and-period-selection{display:flex;justify-content:space-between;padding-bottom:16px;}.tiers{display:grid;justify-content:center;column-gap:16px;grid-template-columns:", function(param) {
    var numberOfTiers = param.numberOfTiers;
    return "repeat(".concat(numberOfTiers, ",1fr)");
}, ";}.tiers-mobile{display:none;}&.is-homepage-pricing{.seats-and-period-selection{padding-bottom:0px;}}@media only screen and (min-width:1440px){width:", old_calcMinWidth1440, ";&.is-homepage-pricing{width:", function(param) {
    var numberOfTiers = param.numberOfTiers;
    return calcMinWidth1440(numberOfTiers);
}, ";}}@media only screen and (min-width:1920px){width:", old_calcMinWidth1920, ";&.is-homepage-pricing{width:", function(param) {
    var numberOfTiers = param.numberOfTiers;
    return calcMinWidth1920(numberOfTiers);
}, ";}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){width:100%;max-width:100%;overflow-x:none;.tiers{display:none;&.tiers-mobile{display:block;width:100%;}}.seats-and-period-selection{display:flex;row-gap:12px;flex-direction:column;justify-content:center;align-items:center;}}");

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/prices-and-features-cards-pricing/product-prices-and-features-cards/product-prices-and-features-cards-component.js
function product_prices_and_features_cards_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_prices_and_features_cards_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_prices_and_features_cards_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

















var ProductPriceAndFeaturesCards = function(param) {
    var productName = param.productName, isTypeformDisabled = param.isTypeformDisabled, hideFreeTier = param.hideFreeTier, hideFreeForever = param.hideFreeForever, translateOrTranslateWithParam = param.translateOrTranslateWithParam, isHomepagePricing = param.isHomepagePricing, cookies = param.cookies, forcePricing = param.forcePricing, abTests = param.abTests, hasFreeTier = param.hasFreeTier, isApplyMaxDiffFeatures = param.isApplyMaxDiffFeatures, defaultSeatsIndex = param.defaultSeatsIndex, pricesAndFeaturesCardsPricing = param.pricesAndFeaturesCardsPricing;
    var _productName = product_pricing_config/* default */.Z[productName], tiers = _productName.tiers, color = _productName.color, colorMobile = _productName.colorMobile, ctaHoverBackgroundColor = _productName.ctaHoverBackgroundColor, ctaHoverBorderColor = _productName.ctaHoverBorderColor, ctaHoverTextColor = _productName.ctaHoverTextColor, hideProductIcon = _productName.hideProductIcon, primaryColor = _productName.primaryColor, secondaryColor = _productName.secondaryColor, productId = _productName.productId, showLearnMoreVideo = _productName.showLearnMoreVideo, showFreeTierComingSoon = _productName.showFreeTierComingSoon, labeledTierFeatures = _productName.labeledTierFeatures;
    var _core = product_pricing_config/* default.core */.Z.core, coreColor = _core.color;
    var SeatsOptionsIndex = defaultSeatsIndex ? defaultSeatsIndex : 0;
    var ref = (0,react.useState)(Object.values(constants.SEATS_OPTIONS)[SeatsOptionsIndex]), seats = ref[0], setSeats = ref[1];
    var ref1 = (0,react.useState)("yearly"), period = ref1[0], setPeriod = ref1[1];
    var ref2 = (0,react.useState)(false), purchaseNowModal = ref2[0], setPurchaseNowModal = ref2[1];
    var ref3 = (0,react.useState)(null), purchaseModalTarget = ref3[0], setPurchaseModalTarget = ref3[1];
    var onPurchaseNowClicked = function(param) {
        var tier = param.tier, target = param.target;
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_PURCHASE_NOW_CLICKED, {
            kind: productName,
            info1: tier.name,
            info2: period,
            info3: seats,
            productKind: productName
        });
        setPurchaseNowModal(true);
        setPurchaseModalTarget(target);
    };
    var setSelectedSeats = (0,react.useCallback)(function(newSelectedSeats) {
        (0,sales_enrichment_service/* storeNumberOfSeats */.uC)(newSelectedSeats);
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_SEAT_BUCKET_CHANGED, {
            info1: newSelectedSeats,
            info2: seats,
            productKind: productName
        });
        setSeats(newSelectedSeats);
    }, [
        productName,
        seats
    ]);
    var setSelectedPeriod = (0,react.useCallback)(function(newSelectedPeriod) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_PERIOD_CHANGED, {
            info1: newSelectedPeriod,
            info2: period,
            productKind: productName
        });
        setPeriod(newSelectedPeriod);
    }, [
        period,
        productName
    ]);
    var getTiers = (0,react.useCallback)(function() {
        // hasFreeTier is cookie monday_has_free_tier based
        // hideFreeTier is a prop passed from the generator
        // free tier will be hidden if hasFreeTier is false OR if hasFreeTier AND hideFreeTier are true
        // TODO: extract to util function or custom hook
        if (!hasFreeTier || hideFreeTier) {
            return tiers.filter(function(tier) {
                return tier.name !== pricing/* TIERS.FREE */.Iy.FREE;
            });
        }
        return tiers;
    }, [
        tiers,
        hideFreeTier,
        hasFreeTier
    ]);
    var getPreviousTierName = function(tier) {
        return (0,plans_service/* getPreviousTierNameByTier */.qD)(tier, getTiers());
    };
    var mostPopularTier = (0,react.useMemo)(function() {
        var relevantTiers = getTiers();
        if (!relevantTiers) return;
        var modifiedTiers = relevantTiers.map(function(tier) {
            return _object_spread_props(product_prices_and_features_cards_component_object_spread({}, tier), {
                tier: tier.name
            });
        });
        var ref = getMostPopularTierAndText(seats, modifiedTiers, null, abTests, cookies, forcePricing), mostPopularTierName = ref.tier;
        return mostPopularTierName;
    }, [
        abTests,
        cookies,
        forcePricing,
        seats,
        tiers
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductPriceAndFeaturesCards, {
        numberOfTiers: getTiers().length,
        className: classnames_default()("container", {
            "is-homepage-pricing": isHomepagePricing
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "seats-and-period-selection",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UsersSelect, {
                        usersCountArray: constants.SEATS_OPTIONS,
                        updateSelectedUserCountCallback: setSelectedSeats,
                        productName: productName,
                        defaultSeatsIndex: SeatsOptionsIndex
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PeriodSelect, {
                        color: color,
                        isHomepagePricing: isHomepagePricing,
                        primaryColor: primaryColor,
                        period: period,
                        onPeriodChange: setSelectedPeriod
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tiers",
                children: getTiers().map(function(tier) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(product_price_and_features_card, {
                        period: period,
                        hideProductIcon: hideProductIcon,
                        productName: productName,
                        tier: tier,
                        tiers: getTiers(),
                        previousTierName: getPreviousTierName(tier),
                        color: color,
                        colorMobile: colorMobile,
                        ctaHoverBackgroundColor: ctaHoverBackgroundColor,
                        ctaHoverBorderColor: ctaHoverBorderColor,
                        ctaHoverTextColor: ctaHoverTextColor,
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        seats: seats,
                        coreColor: coreColor,
                        isMostPopular: mostPopularTier === tier.name,
                        onPurchaseNowClicked: onPurchaseNowClicked,
                        hideFreeForever: hideFreeForever,
                        isHomepagePricing: isHomepagePricing,
                        productId: productId,
                        showLearnMoreVideo: showLearnMoreVideo,
                        showFreeTierComingSoon: showFreeTierComingSoon,
                        isApplyMaxDiffFeatures: isApplyMaxDiffFeatures,
                        labeledTierFeatures: labeledTierFeatures,
                        getQuoteModalFullParagraph: pricesAndFeaturesCardsPricing === null || pricesAndFeaturesCardsPricing === void 0 ? void 0 : pricesAndFeaturesCardsPricing.getQuoteModalFullParagraph,
                        hubspotFromFieldValue: pricesAndFeaturesCardsPricing === null || pricesAndFeaturesCardsPricing === void 0 ? void 0 : pricesAndFeaturesCardsPricing.hubspotFromFieldValue
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tiers tiers-mobile",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel_gallary/* default */.Z, {
                    className: "carousel-item",
                    autoplay: false,
                    wrapAround: false,
                    edgeEasing: "easeBack",
                    slidesToShow: 1,
                    slideIndex: 1,
                    cellAlign: "center",
                    cellSpacing: 16,
                    width: "100vw",
                    slideWidth: 0.7,
                    renderCenterLeftControls: function() {},
                    renderCenterRightControls: function() {},
                    heightMode: "max",
                    children: getTiers().map(function(tier) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(product_price_and_features_card, {
                            period: period,
                            isTypeformDisabled: isTypeformDisabled,
                            hideProductIcon: hideProductIcon,
                            productName: productName,
                            tier: tier,
                            color: color,
                            colorMobile: colorMobile,
                            ctaHoverBackgroundColor: ctaHoverBackgroundColor,
                            ctaHoverBorderColor: ctaHoverBorderColor,
                            ctaHoverTextColor: ctaHoverTextColor,
                            seats: seats,
                            coreColor: coreColor,
                            isMostPopular: mostPopularTier === tier.name,
                            onPurchaseNowClicked: onPurchaseNowClicked,
                            translateOrTranslateWithParam: translateOrTranslateWithParam,
                            labeledTierFeatures: labeledTierFeatures
                        });
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(purchase_now_modal, {
                isOpen: purchaseNowModal,
                signupButton: purchaseModalTarget
            })
        ]
    });
};
/* harmony default export */ var product_prices_and_features_cards_component = (ProductPriceAndFeaturesCards);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./services/pricing/pricing-page/pricing-page-config-service.js
var pricing_page_config_service = __webpack_require__(35624);
// EXTERNAL MODULE: ./services/pricing/pricing-model/services.js + 2 modules
var services = __webpack_require__(3223);
// EXTERNAL MODULE: ./services/pricing-features-service.js + 1 modules
var pricing_features_service = __webpack_require__(97169);
// EXTERNAL MODULE: ./constants/pricing/pricing-page/tier-descriptions/index.js
var tier_descriptions = __webpack_require__(87529);
;// CONCATENATED MODULE: ./services/pricing/pricing-page/tier-descriptions-service.js




var getTierDescriptions = function(clusterId, clusterConfig, param) {
    var abTests = param.abTests, cookies = param.cookies, forcePricing = param.forcePricing, hasStudentPlan = param.hasStudentPlan;
    var _clusterConfig_payments_view;
    var pricingPageConfig = clusterConfig === null || clusterConfig === void 0 ? void 0 : (_clusterConfig_payments_view = clusterConfig.payments_view) === null || _clusterConfig_payments_view === void 0 ? void 0 : _clusterConfig_payments_view.pricing;
    if (!(pricingPageConfig === null || pricingPageConfig === void 0 ? void 0 : pricingPageConfig.tier_descriptions) || !(0,clusterized_pricing_page_service/* isInClusterTest */.dn)(clusterConfig, {
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing
    })) {
        return (0,tier_descriptions/* getDefaultTierDescriptions */.O)({
            hasStudentPlan: hasStudentPlan
        });
    }
    var clusterizedTierDescriptions = (0,clusterized_pricing_page_service/* getTierDescriptionsFromClusterConfig */.vT)(pricingPageConfig, clusterId, {
        abTests: abTests,
        cookies: cookies,
        forcePricing: forcePricing,
        hasStudentPlan: hasStudentPlan
    });
    (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_CLUSTERIZED_INFO_PRESENTED, {
        kind: "user_experience_for_cluster",
        info1: clusterId,
        info2: "payments_view[pricing]",
        data: pricingPageConfig.tier_descriptions,
        placement: "tier_descriptions"
    });
    return clusterizedTierDescriptions;
};

// EXTERNAL MODULE: ./node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(91036);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./services/pricing/discounts-service.js
var discounts_service = __webpack_require__(12403);
// EXTERNAL MODULE: ./services/pricing/periods-service.js
var periods_service = __webpack_require__(70533);
// EXTERNAL MODULE: ./services/pricing/pricing-page/pricing-page-display-service.js
var pricing_page_display_service = __webpack_require__(60004);
// EXTERNAL MODULE: ./segments/desktop/core-components/pricing-action-button/pricing-action-button.js + 2 modules
var pricing_action_button = __webpack_require__(66713);
// EXTERNAL MODULE: ./node_modules/monday-ui-react-core/dist/icons/Check.js
var Check = __webpack_require__(74565);
var Check_default = /*#__PURE__*/__webpack_require__.n(Check);
;// CONCATENATED MODULE: ./segments/desktop/core-components/price-and-features-card/feature-info-with-tooltip/feature-info-with-tooltip.scss.js




var StyledFeatureInfoWithTooltip = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "effj2ms0"
})("position:relative;svg{width:16px;height:16px;pointer-events:none;}path{fill:", colors/* default.asphalt */.Z.asphalt, ";}.feature-tooltip-container{z-index:", z_index/* MODAL_BACKGROUND */.AE, ";display:none;opacity:0;position:absolute;bottom:calc(100% + 14px);transform:translateX(-50%);transition:opacity 0.2s ease;width:300px;.floating-tooltip{position:relative;white-space:normal;text-align:left;}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.floating-tooltip{width:60vw;}}&.auto-width{width:auto;}}&.tooltip-active{.feature-tooltip-container{opacity:1;display:block;}}&:hover{.feature-tooltip-container{opacity:1;display:block;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/price-and-features-card/feature-info-with-tooltip/feature-info-with-tooltip.js





function feature_info_with_tooltip_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}













var FeatureInfoWithTooltip = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(FeatureInfoWithTooltip, PureComponent);
    var _super = (0,_create_super/* default */.Z)(FeatureInfoWithTooltip);
    function FeatureInfoWithTooltip(props) {
        (0,_class_call_check/* default */.Z)(this, FeatureInfoWithTooltip);
        var _this;
        _this = _super.call(this, props);
        feature_info_with_tooltip_define_property((0,_assert_this_initialized/* default */.Z)(_this), "getContainerID", function() {
            var _props = _this.props, index = _props.index, tier = _props.tier, isMobile = _props.isMobile;
            return "featureInfo_".concat(tier, "_").concat(index).concat(isMobile ? "_mobile" : "");
        });
        feature_info_with_tooltip_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onMouseEnterInfoIcon", function() {
            var _props = _this.props, feature = _props.feature, placement = _props.placement, translateOrTranslateWithParam = _props.translateOrTranslateWithParam, tier = _props.tier;
            var name = feature.name;
            BigBrain("track", bigbrain_event_types.PRICING_PAGE_FEATURE_INFO_ICON_HOVER, {
                placement: placement,
                source: bigbrain_event_types.HP_SOURCE,
                kind: name,
                info1: translateOrTranslateWithParam(name),
                info2: tier
            });
        });
        feature_info_with_tooltip_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onMouseLeaveInfoIcon", function() {
            var _props = _this.props, feature = _props.feature, placement = _props.placement, translateOrTranslateWithParam = _props.translateOrTranslateWithParam, tier = _props.tier;
            var name = feature.name;
            BigBrain("track", bigbrain_event_types.PRICING_PAGE_FEATURE_INFO_ICON_EXIT, {
                placement: placement,
                source: bigbrain_event_types.HP_SOURCE,
                kind: name,
                info1: translateOrTranslateWithParam(name),
                info2: tier
            });
        });
        feature_info_with_tooltip_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onFocus", function() {
            _this.onMouseEnterInfoIcon();
            _this.setState({
                tooltipActive: true
            });
        });
        feature_info_with_tooltip_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onBlur", function() {
            _this.onMouseLeaveInfoIcon();
            _this.setState({
                tooltipActive: false
            });
        });
        feature_info_with_tooltip_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onFeatureLinkClick", function(event) {
            event.preventDefault();
            var _props = _this.props, feature = _props.feature, tier = _props.tier;
            var name = feature.name, link = feature.link;
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_FEATURE_LINK_CLICKED, {
                kind: link,
                info1: name,
                info2: tier
            });
            window.open(link, "_blank", "noopener,noreferrer");
        });
        feature_info_with_tooltip_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderInfoIcon", function() {
            var feature = _this.props.feature;
            var link = feature.link;
            if (!link) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing_info_icon/* default */.Z, {});
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                tabIndex: 0,
                href: link,
                onClick: _this.onFeatureLinkClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing_info_icon/* default */.Z, {})
            });
        });
        _this.state = {
            tooltipActive: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(FeatureInfoWithTooltip, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _props = this.props, feature = _props.feature, translateOrTranslateWithParam = _props.translateOrTranslateWithParam;
                var text = feature.text;
                (0,accessibility_service/* setSVGTitle */.B3)("#".concat(this.getContainerID()), translateOrTranslateWithParam(text));
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, feature = _props.feature, featureInfoClassname = _props.featureInfoClassname, translateOrTranslateWithParam = _props.translateOrTranslateWithParam;
                var tooltipActive = this.state.tooltipActive;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFeatureInfoWithTooltip, {
                    className: classnames_default()("feature-info ".concat(featureInfoClassname), {
                        "tooltip-active": tooltipActive
                    }),
                    onMouseEnter: this.onMouseEnterInfoIcon,
                    onMouseLeave: this.onMouseLeaveInfoIcon,
                    tabIndex: 0,
                    onFocus: this.onFocus,
                    onBlur: this.onBlur,
                    onMouseDown: accessibility_service/* preventFocusOnMouseDown */.$R,
                    "aria-label": translateOrTranslateWithParam(feature.text),
                    id: this.getContainerID(),
                    children: [
                        this.renderInfoIcon(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "feature-tooltip-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_component/* default */.Z, {
                                theme: tooltip_constants.DARK_THEME,
                                className: classnames_default()("floating-tooltip"),
                                children: translateOrTranslateWithParam(feature.text)
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return FeatureInfoWithTooltip;
}(react.PureComponent);
/* harmony default export */ var feature_info_with_tooltip = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(FeatureInfoWithTooltip)));
FeatureInfoWithTooltip.defaultProps = {
    placement: "price-and-features-card",
    featureInfoClassname: ""
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./segments/desktop/core-components/price-and-features-card/contact-us-image/contact-us-image.scss.js


var StyledContactUsImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1v3dhep0"
})("display:flex;align-items:center;.contact-us-image-wrapper{margin-left:", pricing_sizes/* CLEAN_FIRST_FOLD_MARGIN */.TR, ";margin-bottom:", pricing_sizes/* CLEAN_FIRST_FOLD_MARGIN */.TR, ";&.basic{img{filter:hue-rotate(-66deg);}}&.standard{img{filter:invert(1);}}&.pro{img{filter:brightness(0.7);}}&.enterprise{img{filter:brightness(0.4);}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/price-and-features-card/contact-us-image/contact-us-image.js






function contact_us_image_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




var ContactUsImage = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ContactUsImage, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ContactUsImage);
    function ContactUsImage() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, ContactUsImage);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        contact_us_image_define_property((0,_assert_this_initialized/* default */.Z)(_this), "getAltText", function() {
            var _props = _this.props, translate = _props.translate, plan = _props.plan;
            var displayName = plan.displayName;
            return "".concat(translate("footer.contactUs"), " - ").concat(translate(displayName));
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(ContactUsImage, [
        {
            key: "render",
            value: function render() {
                var plan = this.props.plan;
                var tier = plan.tier;
                var imgSrc = "/static/img/pricing/contact_us_plan_".concat(tier, ".png");
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContactUsImage, {
                    className: "tier-card-contact-us-image-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "contact-us-image-wrapper ".concat(tier),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: imgSrc,
                            alt: this.getAltText()
                        })
                    })
                });
            }
        }
    ]);
    return ContactUsImage;
}(react.PureComponent);
/* harmony default export */ var contact_us_image = ((0,generic_config_context/* withGenericConfig */.P)(ContactUsImage));

;// CONCATENATED MODULE: ./segments/desktop/core-components/price-and-features-card/price-and-features-card.scss.js






var StyledFreeTierTotalPrice = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1k31ql30"
})("margin:24px 0 12px;font-size:0.8125rem;color:", plans_service/* TIERS_COLORS_MAP */.f_[pricing/* TIERS.FREE */.Iy.FREE].tierContentColor, ";");
var StyledTierName = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h2", {
    target: "e1k31ql31"
})("margin:24px 0 12px;padding-left:", pricing_sizes/* CLEAN_FIRST_FOLD_MARGIN */.TR, ";position:relative;width:100%;display:flex;height:24px;align-items:center;.tier-name-text{font-size:1.238rem;line-height:22px;font-weight:bold;letter-spacing:-0.361538px;margin-right:8px;display:inline;}");
var StyledMostPopular = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e1k31ql32"
})("font-size:0.875rem;position:relative;margin-left:8px;display:flex;height:fit-content;align-items:center;margin-right:4px;.arrow{display:inline-block;width:0px;height:0px;border-top:8px solid transparent;border-bottom:8px solid transparent;border-right:10px solid;top:50%;transform:translateY(-50%);border-right-color:", plans_service/* TIERS_COLORS_MAP */.f_[pricing/* TIERS.FREE */.Iy.FREE].tierContentColor, ";position:absolute;right:100%;}.extra-text{color:", colors/* default.white */.Z.white, ";background-color:", plans_service/* TIERS_COLORS_MAP */.f_[pricing/* TIERS.FREE */.Iy.FREE].tierContentColor, ";padding:6px 8px;border-radius:4px;font-weight:500;flex:0 0;word-break:keep-all;}@media screen and (max-width:", "".concat(vp_sizes.MD, "px"), "){.extra-text{margin-left:4px;font-size:0.8125rem;}}&.with-square-top-text{font-size:0.8125rem;line-height:1rem;margin-left:4px;.extra-text{padding:8px;}}");
var StyledRegularTotalPriceSection = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1k31ql33"
})("display:flex;flex-direction:column;align-items:flex-start;line-height:18px;width:100%;margin-top:25px;margin-bottom:16px;.total-price-text{display:inline;text-align:left;.value{font-weight:600;margin-right:8px;font-size:0.875rem;margin-top:16px;}.information{color:", colors/* default.asphalt */.Z.asphalt, ";margin-top:-10px;height:24px;svg{width:16px;height:16px;pointer-events:none;}path{fill:", colors/* default.asphalt */.Z.asphalt, ";}}}.billing-message{font-size:0.8125rem;color:", colors/* default.mud */.Z.mud, ";}");
var StyledPerSeatPerMonthText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1k31ql34"
})("display:flex;justify-content:flex-start;align-items:center;.plan-price{height:50px;font-size:2.7rem;margin-right:8px;font-weight:300;flex-shrink:0;}.per-user-per-month{display:flex;flex-direction:column;margin-top:8px;white-space:nowrap;text-align:left;& > span{font-weight:100;}}");
var StyledPriceWithoutDiscount = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e1k31ql35"
})('.plan-price-without-discount-inner{position:relative;font-weight:bold;font-size:0.875rem;display:inline;&:after{border-bottom:0.12em solid;content:"";position:absolute;left:-1px;right:-1px;top:50%;}}');
var StyledTierFeature = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1k31ql36"
})("display:flex;justify-content:space-between;margin:0 10% 14px;gap:5px;.tier-feature-name{font-size:0.844rem;line-height:22px;flex:1;}.tier-feature-description{margin-top:4px;margin-left:4px;}");
var StyledPriceAndFeaturesCard = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1k31ql37"
})("display:flex;flex-direction:column;border:1px solid #d5d5d5;margin:8px 8px;border-radius:4px;min-height:770px;width:24%;&:first-of-type{margin-left:0;}&:last-of-type{margin-right:0;}&.chosen{box-shadow:0px 8px 16px rgba(0,0,0,0.166242);}.tier-color-bar{width:100%;height:10px;border-radius:4px 4px 0 0;}.price-card-price-container{display:flex;flex-direction:column;align-items:flex-start;width:100%;.pricing-section{height:", "".concat(pricing_sizes/* TIER_CARD_PRICE_HEIGHT */.I$, "px"), ";margin-left:", pricing_sizes/* CLEAN_FIRST_FOLD_MARGIN */.TR, ";display:flex;flex-direction:column;}.try-cta{margin-left:", pricing_sizes/* CLEAN_FIRST_FOLD_MARGIN */.TR, ";}.tier-description{font-size:0.875rem;font-weight:200;line-height:156%;color:#676869;height:90px;display:flex;align-items:flex-start;text-align:left;padding:0;margin-top:24px;margin-bottom:32px;margin-left:", pricing_sizes/* CLEAN_FIRST_FOLD_MARGIN */.TR, ";margin-right:", pricing_sizes/* CLEAN_FIRST_FOLD_MARGIN */.TR, ";}.tier-learn-more-button{margin-left:", pricing_sizes/* CLEAN_FIRST_FOLD_MARGIN */.TR, ";margin-bottom:16px;}}.separator{width:80%;margin:0 10% 10%;border:1px solid #d5d5d5;}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.try-cta{max-width:80%;}.separator.with-added-margin{margin-top:16px;}}.tier-includes-container{.tier-includes-title{margin-bottom:16px;padding:0 10%;font-weight:600;font-size:1.125rem;line-height:22px;margin-top:unset;}@media only screen and (min-width:990px) and (max-width:1110px){.tier-includes-title{font-size:0.875rem;}}@media only screen and (min-width:1111px) and (max-width:1280px){.tier-includes-title{font-size:1rem;}}@media only screen and (min-width:1281px) and (max-width:1510px){.tier-includes-title{font-size:1.069rem;}}.tier-includes-list{display:flex;flex-direction:column;}}&:not(.hide-ctas){.price-card-price-container{.tier-description.with-learn-more-button{height:34px;}}}&.hide-ctas{.pricing-section.contact-us{height:70px;.tier-card-contact-us-image-container{height:60px;}}.try-cta{margin-bottom:24px;}.price-card-price-container{.tier-description{height:50px;margin-bottom:0;margin-top:8px;}.tier-learn-more-button{height:32px;margin-top:8px;margin-bottom:16px;}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/price-and-features-card/price-and-features-card.js





function price_and_features_card_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}



























var PRICE_CARD_PRICE_CONTAINER_CLASS = "price-card-price-container";
var featureListWithLabel = [
    "pricingPage.features.titles.standardAiCredits",
    "pricingPage.features.titles.proAiCredits",
    "pricingPage.features.titles.enterpriseAiCredits"
];
var FEATURE_LABEL = "New";
var PriceAndFeaturesCard = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(PriceAndFeaturesCard, PureComponent);
    var _super = (0,_create_super/* default */.Z)(PriceAndFeaturesCard);
    function PriceAndFeaturesCard(props) {
        (0,_class_call_check/* default */.Z)(this, PriceAndFeaturesCard);
        var _this;
        _this = _super.call(this, props);
        price_and_features_card_define_property((0,_assert_this_initialized/* default */.Z)(_this), "hasMoreThanFourPlans", function() {
            var plans = _this.props.plans;
            return plans.length > pricing/* NUM_DEFAULT_DISPLAYED_PLANS */.F_;
        });
        price_and_features_card_define_property((0,_assert_this_initialized/* default */.Z)(_this), "getClusterConfigOrDefault", function() {
            var ignoreClusterConfig = _this.props.ignoreClusterConfig;
            return ignoreClusterConfig ? {
                clusterConfig: {}
            } : _this.props.clusterConfig;
        });
        price_and_features_card_define_property((0,_assert_this_initialized/* default */.Z)(_this), "getPricePerSeat", function(price) {
            var _props = _this.props, userCount = _props.userCount, cookies = _props.cookies, forcePricing = _props.forcePricing, abTests = _props.abTests;
            var clusterConfig = _this.getClusterConfigOrDefault();
            var freeUsersCount = (0,discounts_service/* getMaxFreeUsersFromClusterConfig */.qV)(clusterConfig, abTests, cookies, forcePricing) || 0;
            if (freeUsersCount >= userCount) return 0;
            return 100 * price / (userCount - freeUsersCount) / 100;
        });
        price_and_features_card_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderPricePerSeatWithoutDiscountIfNeeded", function() {
            var _props = _this.props, currencyValue = _props.currencyValue, localeId = _props.localeId, planPriceWithoutDiscount = _props.planPriceWithoutDiscount, planPrice = _props.planPrice, cookies = _props.cookies, forcePricing = _props.forcePricing, abTests = _props.abTests;
            var clusterConfig = _this.getClusterConfigOrDefault();
            if ((0,discounts_service/* shouldHideCrossedOutPrice */.pZ)(clusterConfig, abTests, cookies, forcePricing)) return;
            if (planPrice === planPriceWithoutDiscount) return;
            var priceWithoutDiscount = (0,pricing_service/* getCurrencyWithPriceDisplay */.$H)({
                price: _this.getPricePerSeat(planPriceWithoutDiscount).toLocaleString(),
                currency: currencyValue,
                localeId: localeId
            });
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPriceWithoutDiscount, {
                className: "plan-price-without-discount",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "plan-price-without-discount-inner",
                    children: priceWithoutDiscount
                })
            });
        });
        price_and_features_card_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderPricePerSeat", function() {
            var _props = _this.props, currencyValue = _props.currencyValue, localeId = _props.localeId, planPrice = _props.planPrice;
            return (0,pricing_service/* getCurrencyWithPriceDisplay */.$H)({
                price: _this.getPricePerSeat(planPrice).toLocaleString(),
                currency: currencyValue,
                localeId: localeId
            });
        });
        price_and_features_card_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderFullPrice", function() {
            var _props = _this.props, currencyValue = _props.currencyValue, planPrice = _props.planPrice, localeId = _props.localeId;
            return (0,pricing_service/* getCurrencyWithPriceDisplay */.$H)({
                price: planPrice.toLocaleString(),
                currency: currencyValue,
                localeId: localeId,
                hideCurrency: true
            });
        });
        price_and_features_card_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderMostPopularIfNeeded", function() {
            var _props = _this.props, plan = _props.plan, translateOrTranslateWithParam = _props.translateOrTranslateWithParam, userCount = _props.userCount, plans = _props.plans, cookies = _props.cookies, forcePricing = _props.forcePricing, abTests = _props.abTests;
            var clusterConfig = _this.getClusterConfigOrDefault();
            var planColor = (0,plans_service/* getPlanColor */.kP)(plan, true);
            var isSquareTopText = _this.hasMoreThanFourPlans();
            var ref = getMostPopularTierAndText(userCount, plans, clusterConfig, abTests, cookies, forcePricing), mostPopularTier = ref.tier, mostPopularText = ref.text, mostPopularMinimumUsersCount = ref.minimumUsersCount;
            var tier = plan.tier;
            if (mostPopularTier !== tier) return;
            if (mostPopularMinimumUsersCount && userCount < mostPopularMinimumUsersCount) return;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMostPopular, {
                id: tier,
                className: classnames_default()("tier-name-extra", {
                    "with-square-top-text": isSquareTopText
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "arrow",
                        style: {
                            borderRightColor: planColor
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "extra-text",
                        style: {
                            backgroundColor: planColor
                        },
                        children: translateOrTranslateWithParam(mostPopularText)
                    })
                ]
            });
        });
        price_and_features_card_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderTierName", function() {
            var _props = _this.props, plan = _props.plan, translateOrTranslateWithParam = _props.translateOrTranslateWithParam;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTierName, {
                className: "price-card-tier-name",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tier-name-text",
                        id: "tier-name-".concat(plan === null || plan === void 0 ? void 0 : plan.tier),
                        children: strings_default().getCapitilizedString(translateOrTranslateWithParam(plan.displayName))
                    }),
                    _this.renderMostPopularIfNeeded()
                ]
            });
        });
        price_and_features_card_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderFreeTierTotalPrice", function() {
            var _props = _this.props, translateOrTranslateWithParam = _props.translateOrTranslateWithParam, hasStudentPlan = _props.hasStudentPlan;
            var billingMessage = hasStudentPlan ? "pricingPage.freeForDurationOfStudies" : "pricingPage.freeForever";
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFreeTierTotalPrice, {
                className: "price-card-free-tier-total-price",
                dangerouslySetInnerHTML: {
                    __html: translateOrTranslateWithParam(billingMessage)
                }
            });
        });
        price_and_features_card_define_property((0,_assert_this_initialized/* default */.Z)(_this), "getTotalPriceText", function() {
            var _props = _this.props, plan = _props.plan, translateOrTranslateWithParam = _props.translateOrTranslateWithParam, hasStudentPlan = _props.hasStudentPlan, cookies = _props.cookies, forcePricing = _props.forcePricing, abTests = _props.abTests;
            var clusterConfig = _this.getClusterConfigOrDefault();
            var tier = plan.tier;
            var isFree = tier === pricing/* TIERS.FREE */.Iy.FREE;
            var regularBoldText = translateOrTranslateWithParam({
                key: "pricingPage.total.withNumber",
                param: _this.renderFullPrice()
            });
            var yearlyBoldText = translateOrTranslateWithParam({
                key: "pricingPage.total.withNumber.yearly",
                param: _this.renderFullPrice()
            });
            var freeTierBoldText = translateOrTranslateWithParam({
                key: "pricingPage.upToXSeats",
                param: (0,monetization_ab_tests_service/* getFreeTierSeatsCountByAbTest */.FW)({
                    cookies: cookies,
                    abTests: abTests,
                    forcePricing: forcePricing
                })
            });
            var studentPlanBoldText = translateOrTranslateWithParam({
                key: "pricingPage.freeForDurationOfStudies"
            });
            if (isFree) {
                return hasStudentPlan ? studentPlanBoldText : freeTierBoldText;
            }
            return (0,periods_service/* shouldShowYearlyPrices */.B)(clusterConfig, abTests, cookies, forcePricing) ? yearlyBoldText : regularBoldText;
        });
        price_and_features_card_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderRegularTotalPriceSection", function() {
            var _props = _this.props, plan = _props.plan, billingPeriod = _props.billingPeriod, translateOrTranslateWithParam = _props.translateOrTranslateWithParam;
            var tier = plan.tier;
            var isFree = tier === pricing/* TIERS.FREE */.Iy.FREE;
            var boldText = _this.getTotalPriceText();
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRegularTotalPriceSection, {
                className: "price-card-total-price",
                tabIndex: 0,
                onMouseDown: accessibility_service/* preventFocusOnMouseDown */.$R,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "total-price-text",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "value",
                            style: {
                                color: colors/* default.black */.Z.black
                            },
                            children: boldText
                        })
                    }),
                    !isFree && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "billing-message",
                        children: translateOrTranslateWithParam(pricing/* PERIOD_TEXTS */.Jb[billingPeriod].billed)
                    })
                ]
            });
        });
        price_and_features_card_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderPerSeatPerMonthText", function() {
            var _props = _this.props, plan = _props.plan, translateOrTranslateWithParam = _props.translateOrTranslateWithParam, hasStudentPlan = _props.hasStudentPlan, cookies = _props.cookies, forcePricing = _props.forcePricing, abTests = _props.abTests;
            var clusterConfig = _this.getClusterConfigOrDefault();
            var tier = plan.tier;
            var isFree = tier === pricing/* TIERS.FREE */.Iy.FREE && !hasStudentPlan;
            var firstLine = isFree ? "pricingPage.free" : "pricingPage.seatOver";
            var secondLine = isFree ? "pricingPage.forever" : (0,periods_service/* shouldShowYearlyPrices */.B)(clusterConfig, abTests, cookies, forcePricing) ? "pricingPage.year" : "pricingPage.month";
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "per-user-per-month",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: translateOrTranslateWithParam(firstLine)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: translateOrTranslateWithParam(secondLine)
                    })
                ]
            });
        });
        price_and_features_card_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderPriceSection", function() {
            var plan = _this.props.plan;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPerSeatPerMonthText, {
                children: [
                    _this.renderPricePerSeatWithoutDiscountIfNeeded(),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "price-card-price-per-month",
                        style: {
                            color: colors/* default.black */.Z.black
                        },
                        tabIndex: 0,
                        onMouseDown: accessibility_service/* preventFocusOnMouseDown */.$R,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "plan-price",
                                style: {
                                    color: (0,plans_service/* getPlanColor */.kP)(plan, true)
                                },
                                children: _this.renderPricePerSeat()
                            }),
                            _this.renderPerSeatPerMonthText()
                        ]
                    }),
                    _this.renderRegularTotalPriceSection()
                ]
            });
        });
        price_and_features_card_define_property((0,_assert_this_initialized/* default */.Z)(_this), "getTierFeatureAriaLabel", function(feature) {
            var _props = _this.props, plan = _props.plan, translateOrTranslateWithParam = _props.translateOrTranslateWithParam;
            var displayName = plan.displayName;
            return "".concat(translateOrTranslateWithParam(displayName), ": ").concat(sanitize_html_default()(translateOrTranslateWithParam(feature.name), {
                allowedTags: [],
                allowedAttributes: []
            }));
        });
        price_and_features_card_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderTierFeature", function(feature, index) {
            var _props = _this.props, billingPeriod = _props.billingPeriod, plan = _props.plan, translateOrTranslateWithParam = _props.translateOrTranslateWithParam, showFeatureCheckbox = _props.showFeatureCheckbox, isMobile = _props.isMobile;
            var tier = plan.tier;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTierFeature, {
                className: "price-card-tier-feature",
                children: [
                    showFeatureCheckbox && /*#__PURE__*/ (0,jsx_runtime.jsx)((Check_default()), {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "name-and-label",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tier-feature-name",
                                dangerouslySetInnerHTML: {
                                    __html: translateOrTranslateWithParam(feature.name)
                                },
                                "aria-label": _this.getTierFeatureAriaLabel(feature),
                                role: "region",
                                onMouseDown: accessibility_service/* preventFocusOnMouseDown */.$R
                            }),
                            featureListWithLabel.includes(feature.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* default */.Z, {
                                text: FEATURE_LABEL,
                                borderColor: "blue"
                            })
                        ]
                    }),
                    feature.text && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tier-feature-description",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(feature_info_with_tooltip, {
                            feature: feature,
                            placement: "tier-value-card",
                            tier: tier,
                            index: index,
                            isMobile: isMobile,
                            getRegularOrTranslatedText: translateOrTranslateWithParam
                        })
                    })
                ]
            }, index + "_" + billingPeriod);
        });
        price_and_features_card_define_property((0,_assert_this_initialized/* default */.Z)(_this), "shouldIncreaseSeparatorTopMargin", function() {
            // fixes a mobile bug where the separator is higher in the enterprise plan than elsewhere.
            var _props = _this.props, plan = _props.plan, userCount = _props.userCount, cookies = _props.cookies, forcePricing = _props.forcePricing, abTests = _props.abTests;
            var clusterConfig = _this.getClusterConfigOrDefault();
            var tier = plan.tier;
            return tier === pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE && !(0,pricing_service/* shouldSeeContactUs */.j)(pricing/* TIERS.BASIC */.Iy.BASIC, userCount, {
                clusterConfig: clusterConfig,
                cookies: cookies,
                forcePricing: forcePricing,
                abTests: abTests
            });
        });
        price_and_features_card_define_property((0,_assert_this_initialized/* default */.Z)(_this), "getRegularOrLineDropText", function(originalKey) {
            return _this.hasMoreThanFourPlans() ? "".concat(originalKey, ".withLineDrop") : originalKey;
        });
        price_and_features_card_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onPurchaseNowClick", function(e) {
            var _props = _this.props, plan = _props.plan, onPurchaseNowClicked = _props.onPurchaseNowClicked;
            var currentTarget = e.currentTarget;
            var purchaseNowLinkParent = currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.closest("div.".concat(PRICE_CARD_PRICE_CONTAINER_CLASS));
            var signupButton = purchaseNowLinkParent === null || purchaseNowLinkParent === void 0 ? void 0 : purchaseNowLinkParent.querySelector("button");
            onPurchaseNowClicked({
                tier: plan.tier,
                target: signupButton
            });
        });
        price_and_features_card_define_property((0,_assert_this_initialized/* default */.Z)(_this), "shouldShowCTA", function() {
            var _props = _this.props, plan = _props.plan, hidePlanTryForFreeButton = _props.hidePlanTryForFreeButton, isMobileOrTabletBrowser = _props.isMobileOrTabletBrowser;
            if (plan.tier === pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE) return true;
            if (isMobileOrTabletBrowser) return false;
            return !hidePlanTryForFreeButton;
        });
        price_and_features_card_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderLearnMoreVideoCTAOrPlaceholder", function() {
            var _props = _this.props, plan = _props.plan, hidePlanTryForFreeButton = _props.hidePlanTryForFreeButton, localeId = _props.localeId;
            var hasVideo = hasLearnMoreVideo(plan.tier);
            if (!hasVideo && !hidePlanTryForFreeButton) return null;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tier-learn-more-button",
                children: hasVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube_popup_button/* default */.Z, {
                    isWithIcon: true,
                    isWithIconInsteadOfArrow: true,
                    withoutUnderline: true,
                    minPadding: true,
                    outline: true,
                    isWithArrow: false,
                    color: color_consts.WORK_OS_IRIS_COLOR_NAME,
                    iconColor: "outline-dark-blue",
                    buttonText: _this.getLearnMoreButtonText(),
                    videoId: getVideoIdByLocaleAndTier(localeId, plan.tier),
                    buttonDisplayType: hidePlanTryForFreeButton ? button_consts/* SECONDARY_BUTTON_TYPE */.jE : button_consts/* REGULAR_BUTTON_TYPE */.ys,
                    extraEventData: {
                        buttonName: "hp_pp_tier_learn_more",
                        tier: plan.tier,
                        locale: localeId
                    }
                })
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(PriceAndFeaturesCard, [
        {
            key: "getTierIncludesText",
            value: function getTierIncludesText() {
                var _props = this.props, plan = _props.plan, plans = _props.plans, translateOrTranslateWithParam = _props.translateOrTranslateWithParam;
                var previousTierName = (0,plans_service/* getPreviousTierName */.wD)(plan.tier, plans);
                return previousTierName == null ? translateOrTranslateWithParam({
                    key: this.getRegularOrLineDropText("pricingPage.tierCards.planIncludes"),
                    param: translateOrTranslateWithParam(plan.displayName)
                }) : translateOrTranslateWithParam({
                    key: this.getRegularOrLineDropText("pricingPage.tierCards.includesPlanPlus"),
                    param: translateOrTranslateWithParam(previousTierName)
                });
            }
        },
        {
            key: "getLearnMoreButtonText",
            value: function getLearnMoreButtonText() {
                var _props = this.props, plan = _props.plan, translateOrTranslateWithParam = _props.translateOrTranslateWithParam;
                return translateOrTranslateWithParam({
                    key: "pricingPage.tierCards.learnMoreButton",
                    param: translateOrTranslateWithParam(plan.displayName)
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, plan = _props.plan, isChosen = _props.isChosen, translateOrTranslateWithParam = _props.translateOrTranslateWithParam, features = _props.features, userCount = _props.userCount, tierDescription = _props.tierDescription, signupButtonText = _props.signupButtonText, contactUsButtonText = _props.contactUsButtonText, plans = _props.plans, isMobile = _props.isMobile, cookies = _props.cookies, forcePricing = _props.forcePricing, abTests = _props.abTests, billingPeriod = _props.billingPeriod, showLearnMoreVideo = _props.showLearnMoreVideo, hidePlanTryForFreeButton = _props.hidePlanTryForFreeButton;
                var clusterConfig = this.getClusterConfigOrDefault();
                var tierIncludesText = this.getTierIncludesText();
                var isContactUsCard = (0,pricing_service/* shouldSeeContactUs */.j)(plan.tier, userCount, {
                    clusterConfig: clusterConfig,
                    cookies: cookies,
                    forcePricing: forcePricing,
                    abTests: abTests
                });
                var ref = (0,pricing_page_display_service/* getPricingDimensions */.K)(plans), tierCardsDimensions = ref.tierCards;
                var planWidth = tierCardsDimensions.planWidth;
                var tierCardStyle = {
                    width: "".concat(isMobile ? 100 : planWidth, "%")
                };
                var shouldShowLearnMoreVideo = showLearnMoreVideo && hasLearnMoreVideo(plan.tier);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPriceAndFeaturesCard, {
                    className: classnames_default()("price-and-features-card", {
                        chosen: isChosen,
                        "hide-ctas": hidePlanTryForFreeButton
                    }),
                    style: tierCardStyle,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tier-color-bar",
                            style: {
                                backgroundColor: plan.tier === pricing/* TIERS.FREE */.Iy.FREE ? "transparent" : (0,plans_service/* getPlanColor */.kP)(plan, false)
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: PRICE_CARD_PRICE_CONTAINER_CLASS,
                            role: "region",
                            "aria-labelledby": "price-card-aria-".concat(plan === null || plan === void 0 ? void 0 : plan.tier),
                            children: [
                                this.renderTierName(),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("pricing-section", {
                                        "contact-us": isContactUsCard
                                    }),
                                    children: isContactUsCard ? /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_us_image, {
                                        plan: plan
                                    }) : this.renderPriceSection()
                                }),
                                this.shouldShowCTA() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "try-cta",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing_action_button/* default */.Z, {
                                        plan: plan,
                                        userCount: userCount,
                                        placement: "price-and-features-card",
                                        signupButtonText: translateOrTranslateWithParam(signupButtonText),
                                        contactUsButtonText: translateOrTranslateWithParam(contactUsButtonText),
                                        billingPeriod: billingPeriod
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("tier-description", {
                                        "with-learn-more-button": shouldShowLearnMoreVideo
                                    }),
                                    tabIndex: 0,
                                    onMouseDown: accessibility_service/* preventFocusOnMouseDown */.$R,
                                    children: translateOrTranslateWithParam(tierDescription)
                                }),
                                showLearnMoreVideo && this.renderLearnMoreVideoCTAOrPlaceholder()
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("separator", {
                                "with-added-margin": this.shouldIncreaseSeparatorTopMargin()
                            }),
                            style: {
                                borderColor: colors/* default.wolf */.Z.wolf
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tier-includes-container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "tier-includes-title",
                                    dangerouslySetInnerHTML: {
                                        __html: tierIncludesText
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tier-includes-list",
                                    children: features.map(this.renderTierFeature)
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return PriceAndFeaturesCard;
}(react.PureComponent);
/* harmony default export */ var price_and_features_card = ((0,generic_config_context/* withGenericConfig */.P)(PriceAndFeaturesCard));

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/prices-and-features-cards-pricing/components/users-and-periods-picker/users-and-periods-picker-component.scss.js


var StyledUsersAndPeriodSelectionComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "er3a7b70"
})("display:flex;margin-top:16px;justify-content:space-between;margin-bottom:32px;.users-select-container{display:flex;align-items:center;.users-select-label{font-size:0.875rem;margin-right:12px;}.users-select-component{font-size:0.875rem;min-width:190px;height:40px;box-shadow:none;border-radius:4px;.Select-control{background-color:", colors/* default.white */.Z.white, ";border-color:", colors/* default.wolf-gray */.Z["wolf-gray"], ";color:", colors/* default.asphalt */.Z.asphalt, ";}&.selected{.Select-control{background-color:", colors/* default.riverstone */.Z.riverstone, ";border-color:", colors/* default.asphalt */.Z.asphalt, ";color:", colors/* default.mud */.Z.mud, ";}}.Select-arrow-zone{display:flex;position:absolute;right:0;top:50%;transform:translateY(-50%);height:14px;align-items:center;justify-content:center;.Select-arrow{height:8px;width:8px;position:relative;border:none;border-left:1px solid ", colors/* default.asphalt */.Z.asphalt, ";border-bottom:1px solid ", colors/* default.asphalt */.Z.asphalt, ";transform:rotate(-45deg) translateY(-50%);transition:transform 0.1s ease,top 0.1s ease;}}&.is-open > .Select-control .Select-arrow{transform:rotate(-225deg) translateY(50%);top:25%;}}}.payments-pricing-periods-wrapper{display:flex;margin-top:24px;.payments-pricing-periods{font-size:1rem;.period-item-container{display:inline-block;&:not(:last-child){border-right:1px solid;border-color:", colors/* default.black */.Z.black, ";}padding:0 8px;.period-item{outline:none;cursor:pointer;transition:all 0.3s ease;text-transform:capitalize;&:focus.clicked &:hover:not(.selected){color:", colors/* default.brand-dark-blue */.Z["brand-dark-blue"], ";}&.selected{color:", colors/* default.brand-dark-blue */.Z["brand-dark-blue"], ";}}&:focus > .period-item{outline:initial;}}}}");

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/prices-and-features-cards-pricing/components/users-and-periods-picker/users-and-periods-picker-component.js






function users_and_periods_picker_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function users_and_periods_picker_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            users_and_periods_picker_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function users_and_periods_picker_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function users_and_periods_picker_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        users_and_periods_picker_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}














var UsersAndPeriodsPickerComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(UsersAndPeriodsPickerComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(UsersAndPeriodsPickerComponent);
    function UsersAndPeriodsPickerComponent() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, UsersAndPeriodsPickerComponent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        users_and_periods_picker_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onUpdateSelectedBillingPeriod", function(event, periodName) {
            var updateSelectedBillingPeriodCallBack = _this.props.updateSelectedBillingPeriodCallBack;
            updateSelectedBillingPeriodCallBack(periodName);
        });
        users_and_periods_picker_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderPeriodItem", function(periodName, isSelected) {
            var translate = _this.props.translate;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "period-item-container",
                tabIndex: 0,
                onClick: function(event) {
                    return _this.onUpdateSelectedBillingPeriod(event, periodName);
                },
                onKeyDown: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(_this.onUpdateSelectedBillingPeriod, periodName),
                role: "radio",
                "aria-checked": isSelected,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("period-item", {
                        selected: isSelected
                    }),
                    tabIndex: -1,
                    children: translate(pricing/* PERIOD_TEXTS */.Jb[periodName].displayName)
                }, periodName)
            }, periodName);
        });
        users_and_periods_picker_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderPeriodsPicker", function() {
            var _props = _this.props, selectedPeriod = _props.selectedPeriod, translate = _props.translate, cookies = _props.cookies, abTests = _props.abTests, forcePricing = _props.forcePricing, ignoreClusterConfig = _props.ignoreClusterConfig;
            var clusterConfig = (ignoreClusterConfig ? {
                clusterConfig: {}
            } : _this.props).clusterConfig;
            var periods = (0,periods_service/* getPeriods */.K)(clusterConfig, cookies, abTests, forcePricing);
            if (periods.length === 1) return null;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "payments-pricing-periods-wrapper",
                role: "region",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "payments-pricing-periods",
                    role: "radiogroup",
                    "aria-label": translate("pricingPage.periods.title"),
                    children: periods.map(function(periodName) {
                        return _this.renderPeriodItem(periodName, periodName === selectedPeriod);
                    })
                })
            });
        });
        users_and_periods_picker_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "getUsersOptionLabel", function(usersCount) {
            var _props = _this.props, translateOrTranslateWithParam = _props.translateOrTranslateWithParam, cookies = _props.cookies, abTests = _props.abTests, forcePricing = _props.forcePricing, ignoreClusterConfig = _props.ignoreClusterConfig;
            var clusterConfig = (ignoreClusterConfig ? {
                clusterConfig: {}
            } : _this.props).clusterConfig;
            var freeUsersCount = (0,discounts_service/* getMaxFreeUsersFromClusterConfig */.qV)(clusterConfig, abTests, cookies, forcePricing);
            if (freeUsersCount > 0 && usersCount <= freeUsersCount) {
                return translateOrTranslateWithParam({
                    key: "pricingPage.seats.underXFree",
                    param: freeUsersCount
                });
            }
            return "".concat(usersCount, " ").concat(translateOrTranslateWithParam("pricingPage.seats"));
        });
        users_and_periods_picker_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "getUsersSelectOptions", function() {
            var usersCountArray = _this.props.usersCountArray;
            return usersCountArray.map(function(usersCount) {
                return {
                    value: usersCount,
                    label: _this.getUsersOptionLabel(usersCount)
                };
            });
        });
        users_and_periods_picker_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "updateSelectedUserCount", function(param) {
            var value = param.value;
            var updateSelectedUserCountCallback = _this.props.updateSelectedUserCountCallback;
            (0,sales_enrichment_service/* storeNumberOfSeats */.uC)(value);
            updateSelectedUserCountCallback(value);
        });
        users_and_periods_picker_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onMenuOpen", function() {
            var selectedUserCount = _this.props.selectedUserCount;
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_SEAT_DROPDOWN_OPENED, {
                info2: selectedUserCount
            });
        });
        users_and_periods_picker_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderUsersCountSelect", function() {
            var _props = _this.props, selectedUserCount = _props.selectedUserCount, translate = _props.translate;
            var selectedOption = {
                value: selectedUserCount,
                label: _this.getUsersOptionLabel(selectedUserCount)
            };
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "users-select-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "users-select-label",
                        id: "usersSelectLabel",
                        children: translate("pricingPage.chooseTeamSize")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_browser_esm/* default */.ZP, {
                        name: "billing-users-selection",
                        className: "users-select-component",
                        isClearable: false,
                        isSearchable: false,
                        value: selectedOption,
                        onChange: _this.updateSelectedUserCount,
                        onMenuOpen: _this.onMenuOpen,
                        options: _this.getUsersSelectOptions(),
                        "aria-labelledby": "usersSelectLabel",
                        styles: {
                            option: function(base) {
                                return users_and_periods_picker_component_object_spread_props(users_and_periods_picker_component_object_spread({}, base), {
                                    zIndex: z_index/* LAYER_ONE */.KW
                                });
                            }
                        }
                    })
                ]
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(UsersAndPeriodsPickerComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledUsersAndPeriodSelectionComponent, {
                    className: "users-and-period-picker-container",
                    children: [
                        this.renderUsersCountSelect(),
                        this.renderPeriodsPicker()
                    ]
                });
            }
        }
    ]);
    return UsersAndPeriodsPickerComponent;
}(react.PureComponent);
/* harmony default export */ var users_and_periods_picker_component = ((0,generic_config_context/* withGenericConfig */.P)(UsersAndPeriodsPickerComponent));

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/prices-and-features-cards-pricing/components/price-cards/price-cards-component.scss.js



var StyledPriceCardsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eiprdsn0"
})("width:", "".concat(pricing_sizes/* PLANS_COMPONENT_WIDTH */.pP, "px"), ";max-width:calc(100vw - 20px);display:flex;flex-direction:column;align-items:center;margin:0 auto;.top-section{width:100%;}.cards-section{display:flex;justify-content:center;width:100%;}.mobile-price-cards{display:none;flex-direction:column;margin-top:18px;align-items:center;}@media (max-width:", vp_sizes/* ALTERNATE_MAC_BOOK_PRO_MAX_WIDTH_QUERY */.mD, "){.top-section{.users-and-period-picker-container{margin-bottom:24px;}}}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.top-section{.users-and-period-picker-container{flex-direction:column;align-items:center;margin-bottom:16px;.payments-pricing-periods-wrapper{width:100%;.payments-pricing-periods{margin:0 auto;}}}}.cards-section{display:none;}.slider-list{height:1140px !important;}.slider-frame{margin-bottom:80px !important;}.mobile-price-cards{display:flex;.price-and-features-card{width:100%;height:1100px;.price-card-price-container{.tier-description{margin-bottom:32px !important;align-items:center;&.with-more-plans{margin-bottom:64px !important;}}}.price-card-tier-feature{margin:0 10% 14px;display:flex;align-self:stretch;align-items:center;justify-content:space-between;.name-and-label{display:flex;align-items:center;gap:8px;}}}}}@media (max-width:", "".concat(vp_sizes/* XXS */.Mp, "px"), "){.slider-list{height:1180px !important;}.slider-frame{margin-bottom:80px !important;}.mobile-price-cards{display:flex;.price-and-features-card{width:100%;height:1160px;.price-card-tier-name{.tier-name-extra.with-arrow{position:relative;bottom:24px;right:30%;.arrow{display:none;}.extra-text{padding:0 4px;}&.with-square-top-text{right:unset;left:unset;position:absolute;bottom:-10px;.arrow{display:block;}.extra-text{padding:4px 8px;}}}}.price-card-tier-feature{margin:0 10% 14px;}}}}");

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/prices-and-features-cards-pricing/components/price-cards/price-cards-component.js





function price_cards_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}





















var PriceCardsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(PriceCardsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(PriceCardsComponent);
    function PriceCardsComponent(props) {
        (0,_class_call_check/* default */.Z)(this, PriceCardsComponent);
        var _this;
        _this = _super.call(this, props);
        price_cards_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "getCurrency", function() {
            var _props = _this.props, currency = _props.currency, forceCurrency = _props.forceCurrency, cloudfrontViewerCountry = _props.cloudfrontViewerCountry;
            var pricingDefaults = (0,pricing_page_config_service/* getPricingPageConfig */.g)().pricingDefaults;
            return currency || (0,pricing_service/* getCurrencyName */.c0)({
                forceCurrency: forceCurrency,
                pricingDefaults: pricingDefaults,
                countryCode: cloudfrontViewerCountry
            });
        });
        price_cards_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "updateSelectedBillingPeriodCallBack", function(periodName) {
            var _state = _this.state, currentPeriod = _state.billingPeriod;
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_PERIOD_CHANGED, {
                info1: periodName,
                info2: currentPeriod
            });
            _this.setState({
                billingPeriod: periodName
            });
        });
        price_cards_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "updateSelectedUserCountCallback", function(userCount) {
            var _state = _this.state, currentUserCount = _state.userCount;
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_SEAT_BUCKET_CHANGED, {
                info1: userCount,
                info2: currentUserCount
            });
            _this.setState({
                userCount: userCount
            });
        //
        });
        price_cards_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "getPlanPrice", function(plan) {
            var hideDiscount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var _props = _this.props, pricingVersion = _props.pricingVersion, abTests = _props.abTests, cookies = _props.cookies, forcePricing = _props.forcePricing;
            var _state = _this.state, billingPeriod = _state.billingPeriod, userCount = _state.userCount;
            var clusterConfig = _this.getClusterProps().clusterConfig;
            var tier = plan.tier;
            var currencyValue = _this.getCurrency(); // renaming to avoid collision with the context-passed value.
            return _this._pricingModelService.getPlanPrice(tier, currencyValue, billingPeriod, userCount, pricingVersion, clusterConfig, abTests, cookies, forcePricing, hideDiscount);
        });
        price_cards_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "getClusterProps", function() {
            var ignoreClusterConfig = _this.props.ignoreClusterConfig;
            var ref = ignoreClusterConfig ? {
                clusterConfig: {},
                clusterId: undefined
            } : _this.props, clusterConfig = ref.clusterConfig, clusterId = ref.clusterId;
            return {
                clusterConfig: clusterConfig,
                clusterId: clusterId
            };
        });
        price_cards_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onPurchaseNowClicked", function(param) {
            var tier = param.tier, target = param.target;
            var _state = _this.state, period = _state.billingPeriod, userCount = _state.userCount;
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PRICING_PAGE_PURCHASE_NOW_CLICKED, {
                kind: "core",
                info1: tier,
                info2: period,
                info3: userCount
            });
            _this.setState({
                purchaseNowModalOpen: true,
                purchaseModalTarget: target
            });
        });
        price_cards_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderCards", function(isMobile) {
            var _props = _this.props, hasFreeTier = _props.hasFreeTier, hasStudentPlan = _props.hasStudentPlan, signupButtonText = _props.signupButtonText, tierDescriptionConfig = _props.tierDescriptionConfig, tierFeaturesConfig = _props.tierFeaturesConfig, abTests = _props.abTests, cookies = _props.cookies, forcePricing = _props.forcePricing, ignoreClusterConfig = _props.ignoreClusterConfig, showFeatureCheckbox = _props.showFeatureCheckbox, showLearnMoreVideo = _props.showLearnMoreVideo, hidePlanTryForFreeButton = _props.hidePlanTryForFreeButton, translate = _props.translate;
            var ref = _this.getClusterProps(), clusterConfig = ref.clusterConfig, clusterId = ref.clusterId;
            var _state = _this.state, userCount = _state.userCount, billingPeriod = _state.billingPeriod;
            var currencyValue = _this.getCurrency();
            var params = {
                hasStudentPlan: hasStudentPlan,
                hasFreeTier: hasFreeTier,
                abTests: abTests,
                cookies: cookies,
                clusterId: clusterId,
                clusterConfig: clusterConfig,
                forcePricing: forcePricing
            };
            var plans = (0,plans_service/* getPlans */.qY)(params);
            var tierDescriptions = getTierDescriptions(clusterId, clusterConfig, params);
            var getTopFeatures = function(tier) {
                var config = tierFeaturesConfig === null || tierFeaturesConfig === void 0 ? void 0 : tierFeaturesConfig[tier];
                if (isEmpty_default()(config)) {
                    return (0,pricing_features_service/* getPlanValueFeatures */.Yi)(params)[tier];
                }
                return config;
            };
            var getContactUsButtonText = function(abTestVariants, forcePricing) {
                return (0,monetization_ab_tests_service/* shouldShowTalkToSalesCta */.Ce)({
                    abTests: abTestVariants,
                    forcePricing: forcePricing
                }) ? translate("pricingPage.plans.enterprise.cta.talkToSales") : translate("footer.contactUs");
            };
            return plans.map(function(plan) {
                var tier = plan.tier;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(price_and_features_card, {
                    tierDescription: (tierDescriptionConfig === null || tierDescriptionConfig === void 0 ? void 0 : tierDescriptionConfig[tier]) || tierDescriptions[tier],
                    features: getTopFeatures(tier),
                    userCount: userCount,
                    billingPeriod: billingPeriod,
                    planPrice: _this.getPlanPrice(plan),
                    planPriceWithoutDiscount: _this.getPlanPrice(plan, true),
                    plan: plan,
                    currencyValue: currencyValue,
                    signupButtonText: signupButtonText,
                    contactUsButtonText: getContactUsButtonText(abTests, forcePricing),
                    plans: plans,
                    isMobile: isMobile,
                    ignoreClusterConfig: ignoreClusterConfig,
                    abTests: abTests,
                    cookies: cookies,
                    forcePricing: forcePricing,
                    onPurchaseNowClicked: _this.onPurchaseNowClicked,
                    showFeatureCheckbox: showFeatureCheckbox,
                    showLearnMoreVideo: showLearnMoreVideo,
                    hidePlanTryForFreeButton: hidePlanTryForFreeButton
                }, tier);
            });
        });
        price_cards_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderMobileCards", function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel_gallary/* default */.Z, {
                className: "carousel-item",
                autoplay: false,
                wrapAround: false,
                edgeEasing: "easeBack",
                slidesToShow: 1,
                slideIndex: 1,
                cellAlign: "center",
                cellSpacing: 16,
                width: "100vw",
                slideWidth: 0.7,
                renderCenterLeftControls: function() {},
                renderCenterRightControls: function() {},
                heightMode: "max",
                children: _this.renderCards(true)
            });
        });
        var pricingVersion = props.pricingVersion, forcePricing = props.forcePricing, defaultSeatsIndex = props.defaultSeatsIndex;
        var clusterConfig = _this.getClusterProps().clusterConfig;
        _this._pricingModelService = (0,services/* getPricingModelService */.xS)(pricingVersion);
        _this.usersCountArray = _this._pricingModelService.getUserOptions({
            forcePricing: forcePricing,
            clusterConfig: clusterConfig,
            abTests: [],
            cookies: []
        });
        _this.state = {
            userCount: defaultSeatsIndex ? String(Object.values(constants.SEATS_OPTIONS)[defaultSeatsIndex]) : _this._pricingModelService.getDefaultUserOption({
                clusterConfig: clusterConfig,
                forcePricing: forcePricing,
                abTests: [],
                cookies: []
            }),
            billingPeriod: pricing/* PERIODS.yearly */.z5.yearly,
            purchaseNowModalOpen: false,
            purchaseModalTarget: null
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(PriceCardsComponent, [
        {
            key: "render",
            value: function render() {
                var ignoreClusterConfig = this.props.ignoreClusterConfig;
                var _state = this.state, userCount = _state.userCount, billingPeriod = _state.billingPeriod, purchaseNowModalOpen = _state.purchaseNowModalOpen, purchaseModalTarget = _state.purchaseModalTarget;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPriceCardsComponent, {
                    className: "prices-and-features-cards-pricing-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "top-section",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(users_and_periods_picker_component, {
                                updateSelectedBillingPeriodCallBack: this.updateSelectedBillingPeriodCallBack,
                                updateSelectedUserCountCallback: this.updateSelectedUserCountCallback,
                                selectedPeriod: billingPeriod,
                                selectedUserCount: userCount,
                                usersCountArray: this.usersCountArray,
                                ignoreClusterConfig: ignoreClusterConfig
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cards-section",
                            children: this.renderCards()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobile-price-cards",
                            children: this.renderMobileCards()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(purchase_now_modal, {
                            isOpen: purchaseNowModalOpen,
                            signupButton: purchaseModalTarget
                        })
                    ]
                });
            }
        }
    ]);
    return PriceCardsComponent;
}(react.PureComponent);
/* harmony default export */ var price_cards_component = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(PriceCardsComponent)));

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/prices-and-features-cards-pricing/prices-and-features-cards-pricing-component.js




function prices_and_features_cards_pricing_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function prices_and_features_cards_pricing_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            prices_and_features_cards_pricing_component_define_property(target, key, source[key]);
        });
    }
    return target;
}










var PricesAndFeaturesCardsPricingComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(PricesAndFeaturesCardsPricingComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(PricesAndFeaturesCardsPricingComponent);
    function PricesAndFeaturesCardsPricingComponent(props) {
        (0,_class_call_check/* default */.Z)(this, PricesAndFeaturesCardsPricingComponent);
        var _this;
        _this = _super.call(this, props);
        _this.checkIfShouldSeeProductsFeaturesTable();
        return _this;
    }
    (0,_create_class/* default */.Z)(PricesAndFeaturesCardsPricingComponent, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.checkIfShouldSeeProductsFeaturesTable();
            }
        },
        {
            key: "checkIfShouldSeeProductsFeaturesTable",
            value: function checkIfShouldSeeProductsFeaturesTable() {
                var _props = this.props, productName = _props.productName, abTests = _props.abTests, clusterId = _props.clusterId, hasStudentPlan = _props.hasStudentPlan, cookies = _props.cookies, forcePricing = _props.forcePricing, cloudfrontViewerCountry = _props.cloudfrontViewerCountry, isClusterMiniSitePage = _props.isClusterMiniSitePage;
                this.shouldSeeProductsFeaturesTable = productName && (isClusterMiniSitePage || (0,monetization_ab_tests_service/* shouldSeeProductsPricingPage */.GV)({
                    abTests: abTests,
                    clusterId: clusterId,
                    hasStudentPlan: hasStudentPlan,
                    cookies: cookies,
                    forcePricing: forcePricing,
                    cloudfrontViewerCountry: cloudfrontViewerCountry
                }));
                // only used to emit bigbrain event
                (0,monetization_ab_tests_service/* shouldSeeV10PricingVersion */.fy)({
                    cookies: cookies,
                    forcePricing: forcePricing,
                    abTests: abTests
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var isHomepagePricing = this.props.isHomepagePricing;
                // rendering another component because we need access to ab tests as well.
                if (this.shouldSeeProductsFeaturesTable || isHomepagePricing) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(product_prices_and_features_cards_component, prices_and_features_cards_pricing_component_object_spread({}, this.props));
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(price_cards_component, prices_and_features_cards_pricing_component_object_spread({}, this.props));
            }
        }
    ]);
    return PricesAndFeaturesCardsPricingComponent;
}(react.PureComponent);
/* harmony default export */ var prices_and_features_cards_pricing_component = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(PricesAndFeaturesCardsPricingComponent)));
PricesAndFeaturesCardsPricingComponent.defaultProps = default_props;


/***/ }),

/***/ 35624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ getPricingPageConfig; }
/* harmony export */ });
var getPricingPageConfig = function() {
    return {
        template: "LongTemplate",
        title: "monday.com pricing and plans",
        description: "Starting from $8 per user per month, monday.com’s pricing has a plan for everyone.",
        canonicalUrl: "https://monday.com/pricing/",
        withFullstory: true,
        enableHotjar: true,
        fullstoryRecordingFrequency: 100,
        pricingDefaults: {
            defaultCurrency: "usd",
            defaultBillingPeriod: "yearly",
            defaultSelectedPlanName: "standard"
        },
        topbar: {
            preventMenu: false
        },
        socialButtons: {
            show: false
        },
        customersList: [
            {
                name: "outbrain",
                imgSrc: "/static/img/pricing/outbrain.jpg"
            },
            {
                name: "conduit",
                imgSrc: "/static/img/pricing/conduit.jpg"
            },
            {
                name: "wework",
                imgSrc: "/static/img/pricing/wework.jpg"
            },
            {
                name: "spotim",
                imgSrc: "/static/img/pricing/spotim.jpg"
            }
        ],
        tweetIds: [
            "950446913760956420",
            "948055055302770689",
            "948379472830652416",
            "940538468249333760"
        ]
    };
};


/***/ }),

/***/ 59836:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 20916:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 75347:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 31777:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 34017:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 59905:
/***/ (function() {

/* (ignored) */

/***/ })

}]);